var map = {
	"./": [
		12351,
		9,
		94590,
		44826,
		95438
	],
	"./_lib/buildFormatLongFn": [
		35063,
		7,
		35063
	],
	"./_lib/buildFormatLongFn/": [
		35063,
		7,
		35063
	],
	"./_lib/buildFormatLongFn/index": [
		35063,
		7,
		35063
	],
	"./_lib/buildFormatLongFn/index.js": [
		35063,
		7,
		35063
	],
	"./_lib/buildLocalizeFn": [
		64028,
		7,
		64028
	],
	"./_lib/buildLocalizeFn/": [
		64028,
		7,
		64028
	],
	"./_lib/buildLocalizeFn/index": [
		64028,
		7,
		64028
	],
	"./_lib/buildLocalizeFn/index.js": [
		64028,
		7,
		64028
	],
	"./_lib/buildMatchFn": [
		27758,
		7,
		27758
	],
	"./_lib/buildMatchFn/": [
		27758,
		7,
		27758
	],
	"./_lib/buildMatchFn/index": [
		27758,
		7,
		27758
	],
	"./_lib/buildMatchFn/index.js": [
		27758,
		7,
		27758
	],
	"./_lib/buildMatchPatternFn": [
		35568,
		7,
		35568
	],
	"./_lib/buildMatchPatternFn/": [
		35568,
		7,
		35568
	],
	"./_lib/buildMatchPatternFn/index": [
		35568,
		7,
		35568
	],
	"./_lib/buildMatchPatternFn/index.js": [
		35568,
		7,
		35568
	],
	"./af": [
		23413,
		9,
		23413
	],
	"./af/": [
		23413,
		9,
		23413
	],
	"./af/_lib/formatDistance": [
		79254,
		7,
		79254
	],
	"./af/_lib/formatDistance/": [
		79254,
		7,
		79254
	],
	"./af/_lib/formatDistance/index": [
		79254,
		7,
		79254
	],
	"./af/_lib/formatDistance/index.js": [
		79254,
		7,
		79254
	],
	"./af/_lib/formatLong": [
		85475,
		7,
		85475
	],
	"./af/_lib/formatLong/": [
		85475,
		7,
		85475
	],
	"./af/_lib/formatLong/index": [
		85475,
		7,
		85475
	],
	"./af/_lib/formatLong/index.js": [
		85475,
		7,
		85475
	],
	"./af/_lib/formatRelative": [
		20330,
		7,
		20330
	],
	"./af/_lib/formatRelative/": [
		20330,
		7,
		20330
	],
	"./af/_lib/formatRelative/index": [
		20330,
		7,
		20330
	],
	"./af/_lib/formatRelative/index.js": [
		20330,
		7,
		20330
	],
	"./af/_lib/localize": [
		81789,
		7,
		81789
	],
	"./af/_lib/localize/": [
		81789,
		7,
		81789
	],
	"./af/_lib/localize/index": [
		81789,
		7,
		81789
	],
	"./af/_lib/localize/index.js": [
		81789,
		7,
		81789
	],
	"./af/_lib/match": [
		86090,
		7,
		86090
	],
	"./af/_lib/match/": [
		86090,
		7,
		86090
	],
	"./af/_lib/match/index": [
		86090,
		7,
		86090
	],
	"./af/_lib/match/index.js": [
		86090,
		7,
		86090
	],
	"./af/index": [
		74682,
		7,
		74682
	],
	"./af/index.d": [
		13038,
		9,
		13038
	],
	"./af/index.d.ts": [
		13038,
		9,
		13038
	],
	"./af/index.js": [
		74682,
		7,
		74682
	],
	"./af/index.js.flow": [
		59472,
		1,
		59472
	],
	"./af/package": [
		20138,
		3,
		20138
	],
	"./af/package.json": [
		20138,
		3,
		20138
	],
	"./ar": [
		32251,
		9,
		32251
	],
	"./ar-DZ": [
		53186,
		9,
		53186
	],
	"./ar-DZ/": [
		53186,
		9,
		53186
	],
	"./ar-DZ/_lib/formatDistance": [
		6990,
		7,
		6990
	],
	"./ar-DZ/_lib/formatDistance/": [
		6990,
		7,
		6990
	],
	"./ar-DZ/_lib/formatDistance/index": [
		6990,
		7,
		6990
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		6990,
		7,
		6990
	],
	"./ar-DZ/_lib/formatLong": [
		16954,
		7,
		16954
	],
	"./ar-DZ/_lib/formatLong/": [
		16954,
		7,
		16954
	],
	"./ar-DZ/_lib/formatLong/index": [
		16954,
		7,
		16954
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		16954,
		7,
		16954
	],
	"./ar-DZ/_lib/formatRelative": [
		72970,
		7,
		72970
	],
	"./ar-DZ/_lib/formatRelative/": [
		72970,
		7,
		72970
	],
	"./ar-DZ/_lib/formatRelative/index": [
		72970,
		7,
		72970
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		72970,
		7,
		72970
	],
	"./ar-DZ/_lib/localize": [
		63798,
		7,
		63798
	],
	"./ar-DZ/_lib/localize/": [
		63798,
		7,
		63798
	],
	"./ar-DZ/_lib/localize/index": [
		63798,
		7,
		63798
	],
	"./ar-DZ/_lib/localize/index.js": [
		63798,
		7,
		63798
	],
	"./ar-DZ/_lib/match": [
		10138,
		7,
		10138
	],
	"./ar-DZ/_lib/match/": [
		10138,
		7,
		10138
	],
	"./ar-DZ/_lib/match/index": [
		10138,
		7,
		10138
	],
	"./ar-DZ/_lib/match/index.js": [
		10138,
		7,
		10138
	],
	"./ar-DZ/index": [
		80779,
		7,
		80779
	],
	"./ar-DZ/index.d": [
		23910,
		9,
		23910
	],
	"./ar-DZ/index.d.ts": [
		23910,
		9,
		23910
	],
	"./ar-DZ/index.js": [
		80779,
		7,
		80779
	],
	"./ar-DZ/index.js.flow": [
		81753,
		1,
		81753
	],
	"./ar-DZ/package": [
		26890,
		3,
		26890
	],
	"./ar-DZ/package.json": [
		26890,
		3,
		26890
	],
	"./ar-EG": [
		1910,
		9,
		1910
	],
	"./ar-EG/": [
		1910,
		9,
		1910
	],
	"./ar-EG/_lib/formatDistance": [
		73466,
		7,
		73466
	],
	"./ar-EG/_lib/formatDistance/": [
		73466,
		7,
		73466
	],
	"./ar-EG/_lib/formatDistance/index": [
		73466,
		7,
		73466
	],
	"./ar-EG/_lib/formatDistance/index.js": [
		73466,
		7,
		73466
	],
	"./ar-EG/_lib/formatLong": [
		45991,
		7,
		45991
	],
	"./ar-EG/_lib/formatLong/": [
		45991,
		7,
		45991
	],
	"./ar-EG/_lib/formatLong/index": [
		45991,
		7,
		45991
	],
	"./ar-EG/_lib/formatLong/index.js": [
		45991,
		7,
		45991
	],
	"./ar-EG/_lib/formatRelative": [
		17217,
		7,
		17217
	],
	"./ar-EG/_lib/formatRelative/": [
		17217,
		7,
		17217
	],
	"./ar-EG/_lib/formatRelative/index": [
		17217,
		7,
		17217
	],
	"./ar-EG/_lib/formatRelative/index.js": [
		17217,
		7,
		17217
	],
	"./ar-EG/_lib/localize": [
		63069,
		7,
		63069
	],
	"./ar-EG/_lib/localize/": [
		63069,
		7,
		63069
	],
	"./ar-EG/_lib/localize/index": [
		63069,
		7,
		63069
	],
	"./ar-EG/_lib/localize/index.js": [
		63069,
		7,
		63069
	],
	"./ar-EG/_lib/match": [
		24402,
		7,
		24402
	],
	"./ar-EG/_lib/match/": [
		24402,
		7,
		24402
	],
	"./ar-EG/_lib/match/index": [
		24402,
		7,
		24402
	],
	"./ar-EG/_lib/match/index.js": [
		24402,
		7,
		24402
	],
	"./ar-EG/index": [
		47232,
		7,
		47232
	],
	"./ar-EG/index.d": [
		42894,
		9,
		42894
	],
	"./ar-EG/index.d.ts": [
		42894,
		9,
		42894
	],
	"./ar-EG/index.js": [
		47232,
		7,
		47232
	],
	"./ar-EG/index.js.flow": [
		37696,
		1,
		37696
	],
	"./ar-EG/package": [
		97938,
		3,
		97938
	],
	"./ar-EG/package.json": [
		97938,
		3,
		97938
	],
	"./ar-MA": [
		64219,
		9,
		64219
	],
	"./ar-MA/": [
		64219,
		9,
		64219
	],
	"./ar-MA/_lib/formatDistance": [
		80166,
		7,
		80166
	],
	"./ar-MA/_lib/formatDistance/": [
		80166,
		7,
		80166
	],
	"./ar-MA/_lib/formatDistance/index": [
		80166,
		7,
		80166
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		80166,
		7,
		80166
	],
	"./ar-MA/_lib/formatLong": [
		22005,
		7,
		22005
	],
	"./ar-MA/_lib/formatLong/": [
		22005,
		7,
		22005
	],
	"./ar-MA/_lib/formatLong/index": [
		22005,
		7,
		22005
	],
	"./ar-MA/_lib/formatLong/index.js": [
		22005,
		7,
		22005
	],
	"./ar-MA/_lib/formatRelative": [
		72523,
		7,
		72523
	],
	"./ar-MA/_lib/formatRelative/": [
		72523,
		7,
		72523
	],
	"./ar-MA/_lib/formatRelative/index": [
		72523,
		7,
		72523
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		72523,
		7,
		72523
	],
	"./ar-MA/_lib/localize": [
		14763,
		7,
		14763
	],
	"./ar-MA/_lib/localize/": [
		14763,
		7,
		14763
	],
	"./ar-MA/_lib/localize/index": [
		14763,
		7,
		14763
	],
	"./ar-MA/_lib/localize/index.js": [
		14763,
		7,
		14763
	],
	"./ar-MA/_lib/match": [
		36505,
		7,
		36505
	],
	"./ar-MA/_lib/match/": [
		36505,
		7,
		36505
	],
	"./ar-MA/_lib/match/index": [
		36505,
		7,
		36505
	],
	"./ar-MA/_lib/match/index.js": [
		36505,
		7,
		36505
	],
	"./ar-MA/index": [
		99530,
		7,
		99530
	],
	"./ar-MA/index.d": [
		83476,
		9,
		83476
	],
	"./ar-MA/index.d.ts": [
		83476,
		9,
		83476
	],
	"./ar-MA/index.js": [
		99530,
		7,
		99530
	],
	"./ar-MA/index.js.flow": [
		77593,
		1,
		77593
	],
	"./ar-MA/package": [
		7623,
		3,
		7623
	],
	"./ar-MA/package.json": [
		7623,
		3,
		7623
	],
	"./ar-SA": [
		74332,
		9,
		74332
	],
	"./ar-SA/": [
		74332,
		9,
		74332
	],
	"./ar-SA/_lib/formatDistance": [
		3448,
		7,
		3448
	],
	"./ar-SA/_lib/formatDistance/": [
		3448,
		7,
		3448
	],
	"./ar-SA/_lib/formatDistance/index": [
		3448,
		7,
		3448
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		3448,
		7,
		3448
	],
	"./ar-SA/_lib/formatLong": [
		14657,
		7,
		14657
	],
	"./ar-SA/_lib/formatLong/": [
		14657,
		7,
		14657
	],
	"./ar-SA/_lib/formatLong/index": [
		14657,
		7,
		14657
	],
	"./ar-SA/_lib/formatLong/index.js": [
		14657,
		7,
		14657
	],
	"./ar-SA/_lib/formatRelative": [
		9619,
		7,
		9619
	],
	"./ar-SA/_lib/formatRelative/": [
		9619,
		7,
		9619
	],
	"./ar-SA/_lib/formatRelative/index": [
		9619,
		7,
		9619
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		9619,
		7,
		9619
	],
	"./ar-SA/_lib/localize": [
		76797,
		7,
		76797
	],
	"./ar-SA/_lib/localize/": [
		76797,
		7,
		76797
	],
	"./ar-SA/_lib/localize/index": [
		76797,
		7,
		76797
	],
	"./ar-SA/_lib/localize/index.js": [
		76797,
		7,
		76797
	],
	"./ar-SA/_lib/match": [
		29468,
		7,
		29468
	],
	"./ar-SA/_lib/match/": [
		29468,
		7,
		29468
	],
	"./ar-SA/_lib/match/index": [
		29468,
		7,
		29468
	],
	"./ar-SA/_lib/match/index.js": [
		29468,
		7,
		29468
	],
	"./ar-SA/index": [
		6114,
		7,
		6114
	],
	"./ar-SA/index.d": [
		42834,
		9,
		42834
	],
	"./ar-SA/index.d.ts": [
		42834,
		9,
		42834
	],
	"./ar-SA/index.js": [
		6114,
		7,
		6114
	],
	"./ar-SA/index.js.flow": [
		11144,
		1,
		11144
	],
	"./ar-SA/package": [
		26905,
		3,
		26905
	],
	"./ar-SA/package.json": [
		26905,
		3,
		26905
	],
	"./ar-TN": [
		53005,
		9,
		53005
	],
	"./ar-TN/": [
		53005,
		9,
		53005
	],
	"./ar-TN/_lib/formatDistance": [
		42307,
		7,
		42307
	],
	"./ar-TN/_lib/formatDistance/": [
		42307,
		7,
		42307
	],
	"./ar-TN/_lib/formatDistance/index": [
		42307,
		7,
		42307
	],
	"./ar-TN/_lib/formatDistance/index.js": [
		42307,
		7,
		42307
	],
	"./ar-TN/_lib/formatLong": [
		91977,
		7,
		91977
	],
	"./ar-TN/_lib/formatLong/": [
		91977,
		7,
		91977
	],
	"./ar-TN/_lib/formatLong/index": [
		91977,
		7,
		91977
	],
	"./ar-TN/_lib/formatLong/index.js": [
		91977,
		7,
		91977
	],
	"./ar-TN/_lib/formatRelative": [
		97942,
		7,
		97942
	],
	"./ar-TN/_lib/formatRelative/": [
		97942,
		7,
		97942
	],
	"./ar-TN/_lib/formatRelative/index": [
		97942,
		7,
		97942
	],
	"./ar-TN/_lib/formatRelative/index.js": [
		97942,
		7,
		97942
	],
	"./ar-TN/_lib/localize": [
		75544,
		7,
		75544
	],
	"./ar-TN/_lib/localize/": [
		75544,
		7,
		75544
	],
	"./ar-TN/_lib/localize/index": [
		75544,
		7,
		75544
	],
	"./ar-TN/_lib/localize/index.js": [
		75544,
		7,
		75544
	],
	"./ar-TN/_lib/match": [
		84213,
		7,
		84213
	],
	"./ar-TN/_lib/match/": [
		84213,
		7,
		84213
	],
	"./ar-TN/_lib/match/index": [
		84213,
		7,
		84213
	],
	"./ar-TN/_lib/match/index.js": [
		84213,
		7,
		84213
	],
	"./ar-TN/index": [
		93417,
		7,
		93417
	],
	"./ar-TN/index.d": [
		80091,
		9,
		80091
	],
	"./ar-TN/index.d.ts": [
		80091,
		9,
		80091
	],
	"./ar-TN/index.js": [
		93417,
		7,
		93417
	],
	"./ar-TN/index.js.flow": [
		13264,
		1,
		13264
	],
	"./ar-TN/package": [
		80960,
		3,
		80960
	],
	"./ar-TN/package.json": [
		80960,
		3,
		80960
	],
	"./ar/": [
		32251,
		9,
		32251
	],
	"./ar/_lib/formatDistance": [
		13099,
		7,
		13099
	],
	"./ar/_lib/formatDistance/": [
		13099,
		7,
		13099
	],
	"./ar/_lib/formatDistance/index": [
		13099,
		7,
		13099
	],
	"./ar/_lib/formatDistance/index.js": [
		13099,
		7,
		13099
	],
	"./ar/_lib/formatLong": [
		52961,
		7,
		52961
	],
	"./ar/_lib/formatLong/": [
		52961,
		7,
		52961
	],
	"./ar/_lib/formatLong/index": [
		52961,
		7,
		52961
	],
	"./ar/_lib/formatLong/index.js": [
		52961,
		7,
		52961
	],
	"./ar/_lib/formatRelative": [
		35938,
		7,
		35938
	],
	"./ar/_lib/formatRelative/": [
		35938,
		7,
		35938
	],
	"./ar/_lib/formatRelative/index": [
		35938,
		7,
		35938
	],
	"./ar/_lib/formatRelative/index.js": [
		35938,
		7,
		35938
	],
	"./ar/_lib/localize": [
		17261,
		7,
		17261
	],
	"./ar/_lib/localize/": [
		17261,
		7,
		17261
	],
	"./ar/_lib/localize/index": [
		17261,
		7,
		17261
	],
	"./ar/_lib/localize/index.js": [
		17261,
		7,
		17261
	],
	"./ar/_lib/match": [
		64239,
		7,
		64239
	],
	"./ar/_lib/match/": [
		64239,
		7,
		64239
	],
	"./ar/_lib/match/index": [
		64239,
		7,
		64239
	],
	"./ar/_lib/match/index.js": [
		64239,
		7,
		64239
	],
	"./ar/index": [
		74896,
		7,
		74896
	],
	"./ar/index.d": [
		71928,
		9,
		71928
	],
	"./ar/index.d.ts": [
		71928,
		9,
		71928
	],
	"./ar/index.js": [
		74896,
		7,
		74896
	],
	"./ar/index.js.flow": [
		92021,
		1,
		54164
	],
	"./ar/package": [
		69563,
		3,
		69563
	],
	"./ar/package.json": [
		69563,
		3,
		69563
	],
	"./az": [
		80306,
		9,
		80306
	],
	"./az/": [
		80306,
		9,
		80306
	],
	"./az/_lib/formatDistance": [
		81983,
		7,
		81983
	],
	"./az/_lib/formatDistance/": [
		81983,
		7,
		81983
	],
	"./az/_lib/formatDistance/index": [
		81983,
		7,
		81983
	],
	"./az/_lib/formatDistance/index.js": [
		81983,
		7,
		81983
	],
	"./az/_lib/formatLong": [
		76132,
		7,
		76132
	],
	"./az/_lib/formatLong/": [
		76132,
		7,
		76132
	],
	"./az/_lib/formatLong/index": [
		76132,
		7,
		76132
	],
	"./az/_lib/formatLong/index.js": [
		76132,
		7,
		76132
	],
	"./az/_lib/formatRelative": [
		54692,
		7,
		54692
	],
	"./az/_lib/formatRelative/": [
		54692,
		7,
		54692
	],
	"./az/_lib/formatRelative/index": [
		54692,
		7,
		54692
	],
	"./az/_lib/formatRelative/index.js": [
		54692,
		7,
		54692
	],
	"./az/_lib/localize": [
		27385,
		7,
		27385
	],
	"./az/_lib/localize/": [
		27385,
		7,
		27385
	],
	"./az/_lib/localize/index": [
		27385,
		7,
		27385
	],
	"./az/_lib/localize/index.js": [
		27385,
		7,
		27385
	],
	"./az/_lib/match": [
		44877,
		7,
		44877
	],
	"./az/_lib/match/": [
		44877,
		7,
		44877
	],
	"./az/_lib/match/index": [
		44877,
		7,
		44877
	],
	"./az/_lib/match/index.js": [
		44877,
		7,
		44877
	],
	"./az/index": [
		95123,
		7,
		95123
	],
	"./az/index.d": [
		59262,
		9,
		59262
	],
	"./az/index.d.ts": [
		59262,
		9,
		59262
	],
	"./az/index.js": [
		95123,
		7,
		95123
	],
	"./az/index.js.flow": [
		78457,
		1,
		78457
	],
	"./az/package": [
		96713,
		3,
		96713
	],
	"./az/package.json": [
		96713,
		3,
		96713
	],
	"./be": [
		44826,
		9,
		44826,
		83342
	],
	"./be-tarask": [
		94590,
		9,
		94590
	],
	"./be-tarask/": [
		94590,
		9,
		94590
	],
	"./be-tarask/_lib/formatDistance": [
		32822,
		7,
		32822
	],
	"./be-tarask/_lib/formatDistance/": [
		32822,
		7,
		32822
	],
	"./be-tarask/_lib/formatDistance/index": [
		32822,
		7,
		32822
	],
	"./be-tarask/_lib/formatDistance/index.js": [
		32822,
		7,
		32822
	],
	"./be-tarask/_lib/formatLong": [
		52884,
		7,
		52884
	],
	"./be-tarask/_lib/formatLong/": [
		52884,
		7,
		52884
	],
	"./be-tarask/_lib/formatLong/index": [
		52884,
		7,
		52884
	],
	"./be-tarask/_lib/formatLong/index.js": [
		52884,
		7,
		52884
	],
	"./be-tarask/_lib/formatRelative": [
		13681,
		7,
		57223,
		92982,
		13681
	],
	"./be-tarask/_lib/formatRelative/": [
		13681,
		7,
		57223,
		92982,
		13681
	],
	"./be-tarask/_lib/formatRelative/index": [
		13681,
		7,
		57223,
		92982,
		13681
	],
	"./be-tarask/_lib/formatRelative/index.js": [
		13681,
		7,
		57223,
		92982,
		13681
	],
	"./be-tarask/_lib/localize": [
		86361,
		7,
		86361
	],
	"./be-tarask/_lib/localize/": [
		86361,
		7,
		86361
	],
	"./be-tarask/_lib/localize/index": [
		86361,
		7,
		86361
	],
	"./be-tarask/_lib/localize/index.js": [
		86361,
		7,
		86361
	],
	"./be-tarask/_lib/match": [
		62030,
		7,
		62030
	],
	"./be-tarask/_lib/match/": [
		62030,
		7,
		62030
	],
	"./be-tarask/_lib/match/index": [
		62030,
		7,
		62030
	],
	"./be-tarask/_lib/match/index.js": [
		62030,
		7,
		62030
	],
	"./be-tarask/index": [
		83350,
		7,
		57223,
		92982,
		83350
	],
	"./be-tarask/index.d": [
		2812,
		9,
		94590,
		2812
	],
	"./be-tarask/index.d.ts": [
		2812,
		9,
		94590,
		2812
	],
	"./be-tarask/index.js": [
		83350,
		7,
		57223,
		92982,
		83350
	],
	"./be-tarask/index.js.flow": [
		16585,
		1,
		16585
	],
	"./be-tarask/package": [
		64037,
		3,
		64037
	],
	"./be-tarask/package.json": [
		64037,
		3,
		64037
	],
	"./be/": [
		44826,
		9,
		44826,
		83342
	],
	"./be/_lib/formatDistance": [
		86954,
		7,
		86954
	],
	"./be/_lib/formatDistance/": [
		86954,
		7,
		86954
	],
	"./be/_lib/formatDistance/index": [
		86954,
		7,
		86954
	],
	"./be/_lib/formatDistance/index.js": [
		86954,
		7,
		86954
	],
	"./be/_lib/formatLong": [
		67958,
		7,
		67958
	],
	"./be/_lib/formatLong/": [
		67958,
		7,
		67958
	],
	"./be/_lib/formatLong/index": [
		67958,
		7,
		67958
	],
	"./be/_lib/formatLong/index.js": [
		67958,
		7,
		67958
	],
	"./be/_lib/formatRelative": [
		29656,
		7,
		57223,
		92982,
		29656
	],
	"./be/_lib/formatRelative/": [
		29656,
		7,
		57223,
		92982,
		29656
	],
	"./be/_lib/formatRelative/index": [
		29656,
		7,
		57223,
		92982,
		29656
	],
	"./be/_lib/formatRelative/index.js": [
		29656,
		7,
		57223,
		92982,
		29656
	],
	"./be/_lib/localize": [
		11947,
		7,
		11947
	],
	"./be/_lib/localize/": [
		11947,
		7,
		11947
	],
	"./be/_lib/localize/index": [
		11947,
		7,
		11947
	],
	"./be/_lib/localize/index.js": [
		11947,
		7,
		11947
	],
	"./be/_lib/match": [
		68127,
		7,
		68127
	],
	"./be/_lib/match/": [
		68127,
		7,
		68127
	],
	"./be/_lib/match/index": [
		68127,
		7,
		68127
	],
	"./be/_lib/match/index.js": [
		68127,
		7,
		68127
	],
	"./be/index": [
		20379,
		7,
		57223,
		92982,
		20379
	],
	"./be/index.d": [
		73212,
		9,
		44826,
		7298
	],
	"./be/index.d.ts": [
		73212,
		9,
		44826,
		7298
	],
	"./be/index.js": [
		20379,
		7,
		57223,
		92982,
		20379
	],
	"./be/index.js.flow": [
		96781,
		1,
		96781
	],
	"./be/package": [
		70136,
		3,
		70136
	],
	"./be/package.json": [
		70136,
		3,
		70136
	],
	"./bg": [
		26282,
		9,
		26282
	],
	"./bg/": [
		26282,
		9,
		26282
	],
	"./bg/_lib/formatDistance": [
		42697,
		7,
		42697
	],
	"./bg/_lib/formatDistance/": [
		42697,
		7,
		42697
	],
	"./bg/_lib/formatDistance/index": [
		42697,
		7,
		42697
	],
	"./bg/_lib/formatDistance/index.js": [
		42697,
		7,
		42697
	],
	"./bg/_lib/formatLong": [
		60725,
		7,
		60725
	],
	"./bg/_lib/formatLong/": [
		60725,
		7,
		60725
	],
	"./bg/_lib/formatLong/index": [
		60725,
		7,
		60725
	],
	"./bg/_lib/formatLong/index.js": [
		60725,
		7,
		60725
	],
	"./bg/_lib/formatRelative": [
		34985,
		7,
		34985
	],
	"./bg/_lib/formatRelative/": [
		34985,
		7,
		34985
	],
	"./bg/_lib/formatRelative/index": [
		34985,
		7,
		34985
	],
	"./bg/_lib/formatRelative/index.js": [
		34985,
		7,
		34985
	],
	"./bg/_lib/localize": [
		14145,
		7,
		14145
	],
	"./bg/_lib/localize/": [
		14145,
		7,
		14145
	],
	"./bg/_lib/localize/index": [
		14145,
		7,
		14145
	],
	"./bg/_lib/localize/index.js": [
		14145,
		7,
		14145
	],
	"./bg/_lib/match": [
		93429,
		7,
		93429
	],
	"./bg/_lib/match/": [
		93429,
		7,
		93429
	],
	"./bg/_lib/match/index": [
		93429,
		7,
		93429
	],
	"./bg/_lib/match/index.js": [
		93429,
		7,
		93429
	],
	"./bg/index": [
		21614,
		7,
		21614
	],
	"./bg/index.d": [
		36801,
		9,
		36801
	],
	"./bg/index.d.ts": [
		36801,
		9,
		36801
	],
	"./bg/index.js": [
		21614,
		7,
		21614
	],
	"./bg/index.js.flow": [
		90656,
		1,
		90656
	],
	"./bg/package": [
		63986,
		3,
		63986
	],
	"./bg/package.json": [
		63986,
		3,
		63986
	],
	"./bn": [
		58960,
		9,
		58960
	],
	"./bn/": [
		58960,
		9,
		58960
	],
	"./bn/_lib/formatDistance": [
		36406,
		7,
		36406
	],
	"./bn/_lib/formatDistance/": [
		36406,
		7,
		36406
	],
	"./bn/_lib/formatDistance/index": [
		36406,
		7,
		36406
	],
	"./bn/_lib/formatDistance/index.js": [
		36406,
		7,
		36406
	],
	"./bn/_lib/formatLong": [
		62226,
		7,
		62226
	],
	"./bn/_lib/formatLong/": [
		62226,
		7,
		62226
	],
	"./bn/_lib/formatLong/index": [
		62226,
		7,
		62226
	],
	"./bn/_lib/formatLong/index.js": [
		62226,
		7,
		62226
	],
	"./bn/_lib/formatRelative": [
		34758,
		7,
		34758
	],
	"./bn/_lib/formatRelative/": [
		34758,
		7,
		34758
	],
	"./bn/_lib/formatRelative/index": [
		34758,
		7,
		34758
	],
	"./bn/_lib/formatRelative/index.js": [
		34758,
		7,
		34758
	],
	"./bn/_lib/localize": [
		84834,
		9,
		84834
	],
	"./bn/_lib/localize/": [
		84834,
		9,
		84834
	],
	"./bn/_lib/localize/index": [
		84834,
		9,
		84834
	],
	"./bn/_lib/localize/index.js": [
		84834,
		9,
		84834
	],
	"./bn/_lib/match": [
		61772,
		7,
		61772
	],
	"./bn/_lib/match/": [
		61772,
		7,
		61772
	],
	"./bn/_lib/match/index": [
		61772,
		7,
		61772
	],
	"./bn/_lib/match/index.js": [
		61772,
		7,
		61772
	],
	"./bn/index": [
		96893,
		7,
		96893
	],
	"./bn/index.d": [
		89401,
		9,
		89401
	],
	"./bn/index.d.ts": [
		89401,
		9,
		89401
	],
	"./bn/index.js": [
		96893,
		7,
		96893
	],
	"./bn/index.js.flow": [
		69462,
		1,
		4673
	],
	"./bn/package": [
		9958,
		3,
		9958
	],
	"./bn/package.json": [
		9958,
		3,
		9958
	],
	"./bs": [
		52375,
		9,
		52375
	],
	"./bs/": [
		52375,
		9,
		52375
	],
	"./bs/_lib/formatDistance": [
		93482,
		7,
		93482
	],
	"./bs/_lib/formatDistance/": [
		93482,
		7,
		93482
	],
	"./bs/_lib/formatDistance/index": [
		93482,
		7,
		93482
	],
	"./bs/_lib/formatDistance/index.js": [
		93482,
		7,
		93482
	],
	"./bs/_lib/formatLong": [
		26339,
		7,
		26339
	],
	"./bs/_lib/formatLong/": [
		26339,
		7,
		26339
	],
	"./bs/_lib/formatLong/index": [
		26339,
		7,
		26339
	],
	"./bs/_lib/formatLong/index.js": [
		26339,
		7,
		26339
	],
	"./bs/_lib/formatRelative": [
		85291,
		7,
		85291
	],
	"./bs/_lib/formatRelative/": [
		85291,
		7,
		85291
	],
	"./bs/_lib/formatRelative/index": [
		85291,
		7,
		85291
	],
	"./bs/_lib/formatRelative/index.js": [
		85291,
		7,
		85291
	],
	"./bs/_lib/localize": [
		93872,
		7,
		93872
	],
	"./bs/_lib/localize/": [
		93872,
		7,
		93872
	],
	"./bs/_lib/localize/index": [
		93872,
		7,
		93872
	],
	"./bs/_lib/localize/index.js": [
		93872,
		7,
		93872
	],
	"./bs/_lib/match": [
		63300,
		7,
		63300
	],
	"./bs/_lib/match/": [
		63300,
		7,
		63300
	],
	"./bs/_lib/match/index": [
		63300,
		7,
		63300
	],
	"./bs/_lib/match/index.js": [
		63300,
		7,
		63300
	],
	"./bs/index": [
		90904,
		7,
		90904
	],
	"./bs/index.d": [
		909,
		9,
		909
	],
	"./bs/index.d.ts": [
		909,
		9,
		909
	],
	"./bs/index.js": [
		90904,
		7,
		90904
	],
	"./bs/index.js.flow": [
		32167,
		1,
		32167
	],
	"./bs/package": [
		43562,
		3,
		43562
	],
	"./bs/package.json": [
		43562,
		3,
		43562
	],
	"./ca": [
		46876,
		9,
		46876
	],
	"./ca/": [
		46876,
		9,
		46876
	],
	"./ca/_lib/formatDistance": [
		23140,
		7,
		23140
	],
	"./ca/_lib/formatDistance/": [
		23140,
		7,
		23140
	],
	"./ca/_lib/formatDistance/index": [
		23140,
		7,
		23140
	],
	"./ca/_lib/formatDistance/index.js": [
		23140,
		7,
		23140
	],
	"./ca/_lib/formatLong": [
		3319,
		7,
		3319
	],
	"./ca/_lib/formatLong/": [
		3319,
		7,
		3319
	],
	"./ca/_lib/formatLong/index": [
		3319,
		7,
		3319
	],
	"./ca/_lib/formatLong/index.js": [
		3319,
		7,
		3319
	],
	"./ca/_lib/formatRelative": [
		45357,
		7,
		45357
	],
	"./ca/_lib/formatRelative/": [
		45357,
		7,
		45357
	],
	"./ca/_lib/formatRelative/index": [
		45357,
		7,
		45357
	],
	"./ca/_lib/formatRelative/index.js": [
		45357,
		7,
		45357
	],
	"./ca/_lib/localize": [
		14583,
		7,
		14583
	],
	"./ca/_lib/localize/": [
		14583,
		7,
		14583
	],
	"./ca/_lib/localize/index": [
		14583,
		7,
		14583
	],
	"./ca/_lib/localize/index.js": [
		14583,
		7,
		14583
	],
	"./ca/_lib/match": [
		21179,
		7,
		21179
	],
	"./ca/_lib/match/": [
		21179,
		7,
		21179
	],
	"./ca/_lib/match/index": [
		21179,
		7,
		21179
	],
	"./ca/_lib/match/index.js": [
		21179,
		7,
		21179
	],
	"./ca/index": [
		52606,
		7,
		52606
	],
	"./ca/index.d": [
		72435,
		9,
		72435
	],
	"./ca/index.d.ts": [
		72435,
		9,
		72435
	],
	"./ca/index.js": [
		52606,
		7,
		52606
	],
	"./ca/index.js.flow": [
		24722,
		1,
		24722
	],
	"./ca/package": [
		39609,
		3,
		39609
	],
	"./ca/package.json": [
		39609,
		3,
		39609
	],
	"./cs": [
		51301,
		9,
		51301
	],
	"./cs/": [
		51301,
		9,
		51301
	],
	"./cs/_lib/formatDistance": [
		8066,
		7,
		8066
	],
	"./cs/_lib/formatDistance/": [
		8066,
		7,
		8066
	],
	"./cs/_lib/formatDistance/index": [
		8066,
		7,
		8066
	],
	"./cs/_lib/formatDistance/index.js": [
		8066,
		7,
		8066
	],
	"./cs/_lib/formatLong": [
		15081,
		7,
		15081
	],
	"./cs/_lib/formatLong/": [
		15081,
		7,
		15081
	],
	"./cs/_lib/formatLong/index": [
		15081,
		7,
		15081
	],
	"./cs/_lib/formatLong/index.js": [
		15081,
		7,
		15081
	],
	"./cs/_lib/formatRelative": [
		90226,
		7,
		90226
	],
	"./cs/_lib/formatRelative/": [
		90226,
		7,
		90226
	],
	"./cs/_lib/formatRelative/index": [
		90226,
		7,
		90226
	],
	"./cs/_lib/formatRelative/index.js": [
		90226,
		7,
		90226
	],
	"./cs/_lib/localize": [
		86109,
		7,
		86109
	],
	"./cs/_lib/localize/": [
		86109,
		7,
		86109
	],
	"./cs/_lib/localize/index": [
		86109,
		7,
		86109
	],
	"./cs/_lib/localize/index.js": [
		86109,
		7,
		86109
	],
	"./cs/_lib/match": [
		1708,
		7,
		1708
	],
	"./cs/_lib/match/": [
		1708,
		7,
		1708
	],
	"./cs/_lib/match/index": [
		1708,
		7,
		1708
	],
	"./cs/_lib/match/index.js": [
		1708,
		7,
		1708
	],
	"./cs/index": [
		95726,
		7,
		95726
	],
	"./cs/index.d": [
		94246,
		9,
		94246
	],
	"./cs/index.d.ts": [
		94246,
		9,
		94246
	],
	"./cs/index.js": [
		95726,
		7,
		95726
	],
	"./cs/index.js.flow": [
		31220,
		1,
		31220
	],
	"./cs/package": [
		81630,
		3,
		81630
	],
	"./cs/package.json": [
		81630,
		3,
		81630
	],
	"./cy": [
		42836,
		9,
		42836
	],
	"./cy/": [
		42836,
		9,
		42836
	],
	"./cy/_lib/formatDistance": [
		21612,
		7,
		21612
	],
	"./cy/_lib/formatDistance/": [
		21612,
		7,
		21612
	],
	"./cy/_lib/formatDistance/index": [
		21612,
		7,
		21612
	],
	"./cy/_lib/formatDistance/index.js": [
		21612,
		7,
		21612
	],
	"./cy/_lib/formatLong": [
		76573,
		7,
		76573
	],
	"./cy/_lib/formatLong/": [
		76573,
		7,
		76573
	],
	"./cy/_lib/formatLong/index": [
		76573,
		7,
		76573
	],
	"./cy/_lib/formatLong/index.js": [
		76573,
		7,
		76573
	],
	"./cy/_lib/formatRelative": [
		33912,
		7,
		33912
	],
	"./cy/_lib/formatRelative/": [
		33912,
		7,
		33912
	],
	"./cy/_lib/formatRelative/index": [
		33912,
		7,
		33912
	],
	"./cy/_lib/formatRelative/index.js": [
		33912,
		7,
		33912
	],
	"./cy/_lib/localize": [
		25269,
		7,
		25269
	],
	"./cy/_lib/localize/": [
		25269,
		7,
		25269
	],
	"./cy/_lib/localize/index": [
		25269,
		7,
		25269
	],
	"./cy/_lib/localize/index.js": [
		25269,
		7,
		25269
	],
	"./cy/_lib/match": [
		48867,
		7,
		48867
	],
	"./cy/_lib/match/": [
		48867,
		7,
		48867
	],
	"./cy/_lib/match/index": [
		48867,
		7,
		48867
	],
	"./cy/_lib/match/index.js": [
		48867,
		7,
		48867
	],
	"./cy/index": [
		97792,
		7,
		97792
	],
	"./cy/index.d": [
		98483,
		9,
		98483
	],
	"./cy/index.d.ts": [
		98483,
		9,
		98483
	],
	"./cy/index.js": [
		97792,
		7,
		97792
	],
	"./cy/index.js.flow": [
		97305,
		1,
		97305
	],
	"./cy/package": [
		5912,
		3,
		5912
	],
	"./cy/package.json": [
		5912,
		3,
		5912
	],
	"./da": [
		94612,
		9,
		94612
	],
	"./da/": [
		94612,
		9,
		94612
	],
	"./da/_lib/formatDistance": [
		20666,
		7,
		20666
	],
	"./da/_lib/formatDistance/": [
		20666,
		7,
		20666
	],
	"./da/_lib/formatDistance/index": [
		20666,
		7,
		20666
	],
	"./da/_lib/formatDistance/index.js": [
		20666,
		7,
		20666
	],
	"./da/_lib/formatLong": [
		82112,
		7,
		53802
	],
	"./da/_lib/formatLong/": [
		82112,
		7,
		53802
	],
	"./da/_lib/formatLong/index": [
		82112,
		7,
		53802
	],
	"./da/_lib/formatLong/index.js": [
		82112,
		7,
		53802
	],
	"./da/_lib/formatRelative": [
		22130,
		7,
		22130
	],
	"./da/_lib/formatRelative/": [
		22130,
		7,
		22130
	],
	"./da/_lib/formatRelative/index": [
		22130,
		7,
		22130
	],
	"./da/_lib/formatRelative/index.js": [
		22130,
		7,
		22130
	],
	"./da/_lib/localize": [
		94541,
		7,
		94541
	],
	"./da/_lib/localize/": [
		94541,
		7,
		94541
	],
	"./da/_lib/localize/index": [
		94541,
		7,
		94541
	],
	"./da/_lib/localize/index.js": [
		94541,
		7,
		94541
	],
	"./da/_lib/match": [
		91735,
		7,
		91735
	],
	"./da/_lib/match/": [
		91735,
		7,
		91735
	],
	"./da/_lib/match/index": [
		91735,
		7,
		91735
	],
	"./da/_lib/match/index.js": [
		91735,
		7,
		91735
	],
	"./da/index": [
		22616,
		7,
		22616
	],
	"./da/index.d": [
		23760,
		9,
		23760
	],
	"./da/index.d.ts": [
		23760,
		9,
		23760
	],
	"./da/index.js": [
		22616,
		7,
		22616
	],
	"./da/index.js.flow": [
		32166,
		1,
		32166
	],
	"./da/package": [
		2897,
		3,
		2897
	],
	"./da/package.json": [
		2897,
		3,
		2897
	],
	"./de": [
		61369,
		9,
		61369
	],
	"./de-AT": [
		94871,
		9,
		94871
	],
	"./de-AT/": [
		94871,
		9,
		94871
	],
	"./de-AT/_lib/localize": [
		6037,
		7,
		6037
	],
	"./de-AT/_lib/localize/": [
		6037,
		7,
		6037
	],
	"./de-AT/_lib/localize/index": [
		6037,
		7,
		6037
	],
	"./de-AT/_lib/localize/index.js": [
		6037,
		7,
		6037
	],
	"./de-AT/index": [
		15219,
		7,
		15219
	],
	"./de-AT/index.d": [
		16963,
		9,
		16963
	],
	"./de-AT/index.d.ts": [
		16963,
		9,
		16963
	],
	"./de-AT/index.js": [
		15219,
		7,
		15219
	],
	"./de-AT/index.js.flow": [
		37610,
		1,
		37610
	],
	"./de-AT/package": [
		66159,
		3,
		66159
	],
	"./de-AT/package.json": [
		66159,
		3,
		66159
	],
	"./de/": [
		61369,
		9,
		61369
	],
	"./de/_lib/formatDistance": [
		68802,
		7,
		68802
	],
	"./de/_lib/formatDistance/": [
		68802,
		7,
		68802
	],
	"./de/_lib/formatDistance/index": [
		68802,
		7,
		68802
	],
	"./de/_lib/formatDistance/index.js": [
		68802,
		7,
		68802
	],
	"./de/_lib/formatLong": [
		55867,
		7,
		55867
	],
	"./de/_lib/formatLong/": [
		55867,
		7,
		55867
	],
	"./de/_lib/formatLong/index": [
		55867,
		7,
		55867
	],
	"./de/_lib/formatLong/index.js": [
		55867,
		7,
		55867
	],
	"./de/_lib/formatRelative": [
		91068,
		7,
		91068
	],
	"./de/_lib/formatRelative/": [
		91068,
		7,
		91068
	],
	"./de/_lib/formatRelative/index": [
		91068,
		7,
		91068
	],
	"./de/_lib/formatRelative/index.js": [
		91068,
		7,
		91068
	],
	"./de/_lib/localize": [
		51573,
		7,
		51573
	],
	"./de/_lib/localize/": [
		51573,
		7,
		51573
	],
	"./de/_lib/localize/index": [
		51573,
		7,
		51573
	],
	"./de/_lib/localize/index.js": [
		51573,
		7,
		51573
	],
	"./de/_lib/match": [
		40252,
		7,
		40252
	],
	"./de/_lib/match/": [
		40252,
		7,
		40252
	],
	"./de/_lib/match/index": [
		40252,
		7,
		40252
	],
	"./de/_lib/match/index.js": [
		40252,
		7,
		40252
	],
	"./de/index": [
		15407,
		7,
		15407
	],
	"./de/index.d": [
		97265,
		9,
		97265
	],
	"./de/index.d.ts": [
		97265,
		9,
		97265
	],
	"./de/index.js": [
		15407,
		7,
		15407
	],
	"./de/index.js.flow": [
		43152,
		1,
		43152
	],
	"./de/package": [
		1136,
		3,
		1136
	],
	"./de/package.json": [
		1136,
		3,
		1136
	],
	"./el": [
		49724,
		9,
		49724
	],
	"./el/": [
		49724,
		9,
		49724
	],
	"./el/_lib/formatDistance": [
		50002,
		7,
		50002
	],
	"./el/_lib/formatDistance/": [
		50002,
		7,
		50002
	],
	"./el/_lib/formatDistance/index": [
		50002,
		7,
		50002
	],
	"./el/_lib/formatDistance/index.js": [
		50002,
		7,
		50002
	],
	"./el/_lib/formatLong": [
		84909,
		7,
		84909
	],
	"./el/_lib/formatLong/": [
		84909,
		7,
		84909
	],
	"./el/_lib/formatLong/index": [
		84909,
		7,
		84909
	],
	"./el/_lib/formatLong/index.js": [
		84909,
		7,
		84909
	],
	"./el/_lib/formatRelative": [
		54652,
		7,
		54652
	],
	"./el/_lib/formatRelative/": [
		54652,
		7,
		54652
	],
	"./el/_lib/formatRelative/index": [
		54652,
		7,
		54652
	],
	"./el/_lib/formatRelative/index.js": [
		54652,
		7,
		54652
	],
	"./el/_lib/localize": [
		25015,
		7,
		25015
	],
	"./el/_lib/localize/": [
		25015,
		7,
		25015
	],
	"./el/_lib/localize/index": [
		25015,
		7,
		25015
	],
	"./el/_lib/localize/index.js": [
		25015,
		7,
		25015
	],
	"./el/_lib/match": [
		51903,
		7,
		51903
	],
	"./el/_lib/match/": [
		51903,
		7,
		51903
	],
	"./el/_lib/match/index": [
		51903,
		7,
		51903
	],
	"./el/_lib/match/index.js": [
		51903,
		7,
		51903
	],
	"./el/index": [
		66986,
		7,
		66986
	],
	"./el/index.d": [
		43765,
		9,
		43765
	],
	"./el/index.d.ts": [
		43765,
		9,
		43765
	],
	"./el/index.js": [
		66986,
		7,
		66986
	],
	"./el/index.js.flow": [
		61977,
		1,
		61977
	],
	"./el/package": [
		67896,
		3,
		67896
	],
	"./el/package.json": [
		67896,
		3,
		67896
	],
	"./en-AU": [
		26250,
		9,
		26250
	],
	"./en-AU/": [
		26250,
		9,
		26250
	],
	"./en-AU/_lib/formatLong": [
		59195,
		7,
		59195
	],
	"./en-AU/_lib/formatLong/": [
		59195,
		7,
		59195
	],
	"./en-AU/_lib/formatLong/index": [
		59195,
		7,
		59195
	],
	"./en-AU/_lib/formatLong/index.js": [
		59195,
		7,
		59195
	],
	"./en-AU/index": [
		70238,
		7,
		70238
	],
	"./en-AU/index.d": [
		73321,
		9,
		73321
	],
	"./en-AU/index.d.ts": [
		73321,
		9,
		73321
	],
	"./en-AU/index.js": [
		70238,
		7,
		70238
	],
	"./en-AU/index.js.flow": [
		63826,
		1,
		63826
	],
	"./en-AU/package": [
		87445,
		3,
		87445
	],
	"./en-AU/package.json": [
		87445,
		3,
		87445
	],
	"./en-CA": [
		84712,
		9,
		84712
	],
	"./en-CA/": [
		84712,
		9,
		84712
	],
	"./en-CA/_lib/formatDistance": [
		98499,
		7,
		98499
	],
	"./en-CA/_lib/formatDistance/": [
		98499,
		7,
		98499
	],
	"./en-CA/_lib/formatDistance/index": [
		98499,
		7,
		98499
	],
	"./en-CA/_lib/formatDistance/index.js": [
		98499,
		7,
		98499
	],
	"./en-CA/_lib/formatLong": [
		76072,
		7,
		76072
	],
	"./en-CA/_lib/formatLong/": [
		76072,
		7,
		76072
	],
	"./en-CA/_lib/formatLong/index": [
		76072,
		7,
		76072
	],
	"./en-CA/_lib/formatLong/index.js": [
		76072,
		7,
		76072
	],
	"./en-CA/index": [
		52326,
		7,
		52326
	],
	"./en-CA/index.d": [
		22196,
		9,
		22196
	],
	"./en-CA/index.d.ts": [
		22196,
		9,
		22196
	],
	"./en-CA/index.js": [
		52326,
		7,
		52326
	],
	"./en-CA/index.js.flow": [
		56075,
		1,
		56075
	],
	"./en-CA/package": [
		61714,
		3,
		61714
	],
	"./en-CA/package.json": [
		61714,
		3,
		61714
	],
	"./en-GB": [
		11844,
		9,
		11844
	],
	"./en-GB/": [
		11844,
		9,
		11844
	],
	"./en-GB/_lib/formatLong": [
		37679,
		7,
		37679
	],
	"./en-GB/_lib/formatLong/": [
		37679,
		7,
		37679
	],
	"./en-GB/_lib/formatLong/index": [
		37679,
		7,
		37679
	],
	"./en-GB/_lib/formatLong/index.js": [
		37679,
		7,
		37679
	],
	"./en-GB/index": [
		97302,
		7,
		97302
	],
	"./en-GB/index.d": [
		89443,
		9,
		89443
	],
	"./en-GB/index.d.ts": [
		89443,
		9,
		89443
	],
	"./en-GB/index.js": [
		97302,
		7,
		97302
	],
	"./en-GB/index.js.flow": [
		47317,
		1,
		47317
	],
	"./en-GB/package": [
		79204,
		3,
		79204
	],
	"./en-GB/package.json": [
		79204,
		3,
		79204
	],
	"./en-IE": [
		45986,
		9,
		45986
	],
	"./en-IE/": [
		45986,
		9,
		45986
	],
	"./en-IE/index": [
		38059,
		7,
		38059
	],
	"./en-IE/index.d": [
		4786,
		9,
		4786
	],
	"./en-IE/index.d.ts": [
		4786,
		9,
		4786
	],
	"./en-IE/index.js": [
		38059,
		7,
		38059
	],
	"./en-IE/index.js.flow": [
		81427,
		1,
		81427
	],
	"./en-IE/package": [
		98472,
		3,
		98472
	],
	"./en-IE/package.json": [
		98472,
		3,
		98472
	],
	"./en-IN": [
		18085,
		9,
		18085
	],
	"./en-IN/": [
		18085,
		9,
		18085
	],
	"./en-IN/_lib/formatLong": [
		35759,
		7,
		35759
	],
	"./en-IN/_lib/formatLong/": [
		35759,
		7,
		35759
	],
	"./en-IN/_lib/formatLong/index": [
		35759,
		7,
		35759
	],
	"./en-IN/_lib/formatLong/index.js": [
		35759,
		7,
		35759
	],
	"./en-IN/index": [
		2392,
		7,
		2392
	],
	"./en-IN/index.d": [
		65504,
		9,
		65504
	],
	"./en-IN/index.d.ts": [
		65504,
		9,
		65504
	],
	"./en-IN/index.js": [
		2392,
		7,
		2392
	],
	"./en-IN/index.js.flow": [
		2715,
		1,
		2715
	],
	"./en-IN/package": [
		52063,
		3,
		52063
	],
	"./en-IN/package.json": [
		52063,
		3,
		52063
	],
	"./en-NZ": [
		17603,
		9,
		17603
	],
	"./en-NZ/": [
		17603,
		9,
		17603
	],
	"./en-NZ/_lib/formatLong": [
		79607,
		7,
		79607
	],
	"./en-NZ/_lib/formatLong/": [
		79607,
		7,
		79607
	],
	"./en-NZ/_lib/formatLong/index": [
		79607,
		7,
		79607
	],
	"./en-NZ/_lib/formatLong/index.js": [
		79607,
		7,
		79607
	],
	"./en-NZ/index": [
		23893,
		7,
		23893
	],
	"./en-NZ/index.d": [
		3077,
		9,
		3077
	],
	"./en-NZ/index.d.ts": [
		3077,
		9,
		3077
	],
	"./en-NZ/index.js": [
		23893,
		7,
		23893
	],
	"./en-NZ/index.js.flow": [
		55509,
		1,
		55509
	],
	"./en-NZ/package": [
		84177,
		3,
		84177
	],
	"./en-NZ/package.json": [
		84177,
		3,
		84177
	],
	"./en-US": [
		69201,
		9
	],
	"./en-US/": [
		69201,
		9
	],
	"./en-US/_lib/formatDistance": [
		42682,
		7,
		42682
	],
	"./en-US/_lib/formatDistance/": [
		42682,
		7,
		42682
	],
	"./en-US/_lib/formatDistance/index": [
		42682,
		7,
		42682
	],
	"./en-US/_lib/formatDistance/index.js": [
		42682,
		7,
		42682
	],
	"./en-US/_lib/formatLong": [
		12128,
		7,
		12128
	],
	"./en-US/_lib/formatLong/": [
		12128,
		7,
		12128
	],
	"./en-US/_lib/formatLong/index": [
		12128,
		7,
		12128
	],
	"./en-US/_lib/formatLong/index.js": [
		12128,
		7,
		12128
	],
	"./en-US/_lib/formatRelative": [
		62118,
		7,
		62118
	],
	"./en-US/_lib/formatRelative/": [
		62118,
		7,
		62118
	],
	"./en-US/_lib/formatRelative/index": [
		62118,
		7,
		62118
	],
	"./en-US/_lib/formatRelative/index.js": [
		62118,
		7,
		62118
	],
	"./en-US/_lib/localize": [
		58336,
		7,
		58336
	],
	"./en-US/_lib/localize/": [
		58336,
		7,
		58336
	],
	"./en-US/_lib/localize/index": [
		58336,
		7,
		58336
	],
	"./en-US/_lib/localize/index.js": [
		58336,
		7,
		58336
	],
	"./en-US/_lib/match": [
		38787,
		7,
		38787
	],
	"./en-US/_lib/match/": [
		38787,
		7,
		38787
	],
	"./en-US/_lib/match/index": [
		38787,
		7,
		38787
	],
	"./en-US/_lib/match/index.js": [
		38787,
		7,
		38787
	],
	"./en-US/index": [
		30609,
		7,
		30609
	],
	"./en-US/index.d": [
		27138,
		9,
		27138
	],
	"./en-US/index.d.ts": [
		27138,
		9,
		27138
	],
	"./en-US/index.js": [
		30609,
		7,
		30609
	],
	"./en-US/index.js.flow": [
		41647,
		1,
		41647
	],
	"./en-US/package": [
		89049,
		3,
		89049
	],
	"./en-US/package.json": [
		89049,
		3,
		89049
	],
	"./en-ZA": [
		16458,
		9,
		16458
	],
	"./en-ZA/": [
		16458,
		9,
		16458
	],
	"./en-ZA/_lib/formatLong": [
		54168,
		7,
		54168
	],
	"./en-ZA/_lib/formatLong/": [
		54168,
		7,
		54168
	],
	"./en-ZA/_lib/formatLong/index": [
		54168,
		7,
		54168
	],
	"./en-ZA/_lib/formatLong/index.js": [
		54168,
		7,
		54168
	],
	"./en-ZA/index": [
		80583,
		7,
		80583
	],
	"./en-ZA/index.d": [
		59189,
		9,
		59189
	],
	"./en-ZA/index.d.ts": [
		59189,
		9,
		59189
	],
	"./en-ZA/index.js": [
		80583,
		7,
		80583
	],
	"./en-ZA/index.js.flow": [
		7902,
		1,
		7902
	],
	"./en-ZA/package": [
		96657,
		3,
		96657
	],
	"./en-ZA/package.json": [
		96657,
		3,
		96657
	],
	"./eo": [
		13478,
		9,
		13478
	],
	"./eo/": [
		13478,
		9,
		13478
	],
	"./eo/_lib/formatDistance": [
		52352,
		7,
		52352
	],
	"./eo/_lib/formatDistance/": [
		52352,
		7,
		52352
	],
	"./eo/_lib/formatDistance/index": [
		52352,
		7,
		52352
	],
	"./eo/_lib/formatDistance/index.js": [
		52352,
		7,
		52352
	],
	"./eo/_lib/formatLong": [
		40575,
		7,
		40575
	],
	"./eo/_lib/formatLong/": [
		40575,
		7,
		40575
	],
	"./eo/_lib/formatLong/index": [
		40575,
		7,
		40575
	],
	"./eo/_lib/formatLong/index.js": [
		40575,
		7,
		40575
	],
	"./eo/_lib/formatRelative": [
		34310,
		7,
		34310
	],
	"./eo/_lib/formatRelative/": [
		34310,
		7,
		34310
	],
	"./eo/_lib/formatRelative/index": [
		34310,
		7,
		34310
	],
	"./eo/_lib/formatRelative/index.js": [
		34310,
		7,
		34310
	],
	"./eo/_lib/localize": [
		28386,
		7,
		28386
	],
	"./eo/_lib/localize/": [
		28386,
		7,
		28386
	],
	"./eo/_lib/localize/index": [
		28386,
		7,
		28386
	],
	"./eo/_lib/localize/index.js": [
		28386,
		7,
		28386
	],
	"./eo/_lib/match": [
		56126,
		7,
		56126
	],
	"./eo/_lib/match/": [
		56126,
		7,
		56126
	],
	"./eo/_lib/match/index": [
		56126,
		7,
		56126
	],
	"./eo/_lib/match/index.js": [
		56126,
		7,
		56126
	],
	"./eo/index": [
		56546,
		7,
		56546
	],
	"./eo/index.d": [
		91568,
		9,
		91568
	],
	"./eo/index.d.ts": [
		91568,
		9,
		91568
	],
	"./eo/index.js": [
		56546,
		7,
		56546
	],
	"./eo/index.js.flow": [
		17585,
		1,
		17585
	],
	"./eo/package": [
		4346,
		3,
		4346
	],
	"./eo/package.json": [
		4346,
		3,
		4346
	],
	"./es": [
		13830,
		9,
		13830
	],
	"./es/": [
		13830,
		9,
		13830
	],
	"./es/_lib/formatDistance": [
		25247,
		7,
		25247
	],
	"./es/_lib/formatDistance/": [
		25247,
		7,
		25247
	],
	"./es/_lib/formatDistance/index": [
		25247,
		7,
		25247
	],
	"./es/_lib/formatDistance/index.js": [
		25247,
		7,
		25247
	],
	"./es/_lib/formatLong": [
		58953,
		7,
		58953
	],
	"./es/_lib/formatLong/": [
		58953,
		7,
		58953
	],
	"./es/_lib/formatLong/index": [
		58953,
		7,
		58953
	],
	"./es/_lib/formatLong/index.js": [
		58953,
		7,
		58953
	],
	"./es/_lib/formatRelative": [
		78293,
		7,
		78293
	],
	"./es/_lib/formatRelative/": [
		78293,
		7,
		78293
	],
	"./es/_lib/formatRelative/index": [
		78293,
		7,
		78293
	],
	"./es/_lib/formatRelative/index.js": [
		78293,
		7,
		78293
	],
	"./es/_lib/localize": [
		4291,
		7,
		4291
	],
	"./es/_lib/localize/": [
		4291,
		7,
		4291
	],
	"./es/_lib/localize/index": [
		4291,
		7,
		4291
	],
	"./es/_lib/localize/index.js": [
		4291,
		7,
		4291
	],
	"./es/_lib/match": [
		87878,
		7,
		87878
	],
	"./es/_lib/match/": [
		87878,
		7,
		87878
	],
	"./es/_lib/match/index": [
		87878,
		7,
		87878
	],
	"./es/_lib/match/index.js": [
		87878,
		7,
		87878
	],
	"./es/index": [
		1259,
		7,
		1259
	],
	"./es/index.d": [
		58587,
		9,
		58587
	],
	"./es/index.d.ts": [
		58587,
		9,
		58587
	],
	"./es/index.js": [
		1259,
		7,
		1259
	],
	"./es/index.js.flow": [
		84319,
		1,
		84319
	],
	"./es/package": [
		280,
		3,
		280
	],
	"./es/package.json": [
		280,
		3,
		280
	],
	"./et": [
		1606,
		9,
		1606
	],
	"./et/": [
		1606,
		9,
		1606
	],
	"./et/_lib/formatDistance": [
		36243,
		7,
		36243
	],
	"./et/_lib/formatDistance/": [
		36243,
		7,
		36243
	],
	"./et/_lib/formatDistance/index": [
		36243,
		7,
		36243
	],
	"./et/_lib/formatDistance/index.js": [
		36243,
		7,
		36243
	],
	"./et/_lib/formatLong": [
		58209,
		7,
		58209
	],
	"./et/_lib/formatLong/": [
		58209,
		7,
		58209
	],
	"./et/_lib/formatLong/index": [
		58209,
		7,
		58209
	],
	"./et/_lib/formatLong/index.js": [
		58209,
		7,
		58209
	],
	"./et/_lib/formatRelative": [
		13585,
		7,
		13585
	],
	"./et/_lib/formatRelative/": [
		13585,
		7,
		13585
	],
	"./et/_lib/formatRelative/index": [
		13585,
		7,
		13585
	],
	"./et/_lib/formatRelative/index.js": [
		13585,
		7,
		13585
	],
	"./et/_lib/localize": [
		48308,
		7,
		48308
	],
	"./et/_lib/localize/": [
		48308,
		7,
		48308
	],
	"./et/_lib/localize/index": [
		48308,
		7,
		48308
	],
	"./et/_lib/localize/index.js": [
		48308,
		7,
		48308
	],
	"./et/_lib/match": [
		70620,
		7,
		70620
	],
	"./et/_lib/match/": [
		70620,
		7,
		70620
	],
	"./et/_lib/match/index": [
		70620,
		7,
		70620
	],
	"./et/_lib/match/index.js": [
		70620,
		7,
		70620
	],
	"./et/index": [
		22052,
		7,
		22052
	],
	"./et/index.d": [
		66736,
		9,
		66736
	],
	"./et/index.d.ts": [
		66736,
		9,
		66736
	],
	"./et/index.js": [
		22052,
		7,
		22052
	],
	"./et/index.js.flow": [
		5600,
		1,
		5600
	],
	"./et/package": [
		88581,
		3,
		88581
	],
	"./et/package.json": [
		88581,
		3,
		88581
	],
	"./eu": [
		82424,
		9,
		82424
	],
	"./eu/": [
		82424,
		9,
		82424
	],
	"./eu/_lib/formatDistance": [
		68789,
		7,
		68789
	],
	"./eu/_lib/formatDistance/": [
		68789,
		7,
		68789
	],
	"./eu/_lib/formatDistance/index": [
		68789,
		7,
		68789
	],
	"./eu/_lib/formatDistance/index.js": [
		68789,
		7,
		68789
	],
	"./eu/_lib/formatLong": [
		9410,
		7,
		9410
	],
	"./eu/_lib/formatLong/": [
		9410,
		7,
		9410
	],
	"./eu/_lib/formatLong/index": [
		9410,
		7,
		9410
	],
	"./eu/_lib/formatLong/index.js": [
		9410,
		7,
		9410
	],
	"./eu/_lib/formatRelative": [
		24774,
		7,
		24774
	],
	"./eu/_lib/formatRelative/": [
		24774,
		7,
		24774
	],
	"./eu/_lib/formatRelative/index": [
		24774,
		7,
		24774
	],
	"./eu/_lib/formatRelative/index.js": [
		24774,
		7,
		24774
	],
	"./eu/_lib/localize": [
		43010,
		7,
		43010
	],
	"./eu/_lib/localize/": [
		43010,
		7,
		43010
	],
	"./eu/_lib/localize/index": [
		43010,
		7,
		43010
	],
	"./eu/_lib/localize/index.js": [
		43010,
		7,
		43010
	],
	"./eu/_lib/match": [
		46965,
		7,
		46965
	],
	"./eu/_lib/match/": [
		46965,
		7,
		46965
	],
	"./eu/_lib/match/index": [
		46965,
		7,
		46965
	],
	"./eu/_lib/match/index.js": [
		46965,
		7,
		46965
	],
	"./eu/index": [
		48734,
		7,
		48734
	],
	"./eu/index.d": [
		38578,
		9,
		38578
	],
	"./eu/index.d.ts": [
		38578,
		9,
		38578
	],
	"./eu/index.js": [
		48734,
		7,
		48734
	],
	"./eu/index.js.flow": [
		4407,
		1,
		4407
	],
	"./eu/package": [
		72634,
		3,
		72634
	],
	"./eu/package.json": [
		72634,
		3,
		72634
	],
	"./fa-IR": [
		72191,
		9,
		72191
	],
	"./fa-IR/": [
		72191,
		9,
		72191
	],
	"./fa-IR/_lib/formatDistance": [
		48073,
		7,
		48073
	],
	"./fa-IR/_lib/formatDistance/": [
		48073,
		7,
		48073
	],
	"./fa-IR/_lib/formatDistance/index": [
		48073,
		7,
		48073
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		48073,
		7,
		48073
	],
	"./fa-IR/_lib/formatLong": [
		2924,
		7,
		2924
	],
	"./fa-IR/_lib/formatLong/": [
		2924,
		7,
		2924
	],
	"./fa-IR/_lib/formatLong/index": [
		2924,
		7,
		2924
	],
	"./fa-IR/_lib/formatLong/index.js": [
		2924,
		7,
		2924
	],
	"./fa-IR/_lib/formatRelative": [
		8536,
		7,
		8536
	],
	"./fa-IR/_lib/formatRelative/": [
		8536,
		7,
		8536
	],
	"./fa-IR/_lib/formatRelative/index": [
		8536,
		7,
		8536
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		8536,
		7,
		8536
	],
	"./fa-IR/_lib/localize": [
		65444,
		7,
		65444
	],
	"./fa-IR/_lib/localize/": [
		65444,
		7,
		65444
	],
	"./fa-IR/_lib/localize/index": [
		65444,
		7,
		65444
	],
	"./fa-IR/_lib/localize/index.js": [
		65444,
		7,
		65444
	],
	"./fa-IR/_lib/match": [
		32764,
		7,
		32764
	],
	"./fa-IR/_lib/match/": [
		32764,
		7,
		32764
	],
	"./fa-IR/_lib/match/index": [
		32764,
		7,
		32764
	],
	"./fa-IR/_lib/match/index.js": [
		32764,
		7,
		32764
	],
	"./fa-IR/index": [
		17432,
		7,
		17432
	],
	"./fa-IR/index.d": [
		36850,
		9,
		36850
	],
	"./fa-IR/index.d.ts": [
		36850,
		9,
		36850
	],
	"./fa-IR/index.js": [
		17432,
		7,
		17432
	],
	"./fa-IR/index.js.flow": [
		87971,
		1,
		87971
	],
	"./fa-IR/package": [
		83136,
		3,
		83136
	],
	"./fa-IR/package.json": [
		83136,
		3,
		83136
	],
	"./fi": [
		20252,
		9,
		20252
	],
	"./fi/": [
		20252,
		9,
		20252
	],
	"./fi/_lib/formatDistance": [
		26136,
		7,
		26136
	],
	"./fi/_lib/formatDistance/": [
		26136,
		7,
		26136
	],
	"./fi/_lib/formatDistance/index": [
		26136,
		7,
		26136
	],
	"./fi/_lib/formatDistance/index.js": [
		26136,
		7,
		26136
	],
	"./fi/_lib/formatLong": [
		20173,
		7,
		20173
	],
	"./fi/_lib/formatLong/": [
		20173,
		7,
		20173
	],
	"./fi/_lib/formatLong/index": [
		20173,
		7,
		20173
	],
	"./fi/_lib/formatLong/index.js": [
		20173,
		7,
		20173
	],
	"./fi/_lib/formatRelative": [
		9370,
		7,
		9370
	],
	"./fi/_lib/formatRelative/": [
		9370,
		7,
		9370
	],
	"./fi/_lib/formatRelative/index": [
		9370,
		7,
		9370
	],
	"./fi/_lib/formatRelative/index.js": [
		9370,
		7,
		9370
	],
	"./fi/_lib/localize": [
		42885,
		7,
		42885
	],
	"./fi/_lib/localize/": [
		42885,
		7,
		42885
	],
	"./fi/_lib/localize/index": [
		42885,
		7,
		42885
	],
	"./fi/_lib/localize/index.js": [
		42885,
		7,
		42885
	],
	"./fi/_lib/match": [
		85266,
		7,
		85266
	],
	"./fi/_lib/match/": [
		85266,
		7,
		85266
	],
	"./fi/_lib/match/index": [
		85266,
		7,
		85266
	],
	"./fi/_lib/match/index.js": [
		85266,
		7,
		85266
	],
	"./fi/index": [
		80925,
		7,
		80925
	],
	"./fi/index.d": [
		29698,
		9,
		29698
	],
	"./fi/index.d.ts": [
		29698,
		9,
		29698
	],
	"./fi/index.js": [
		80925,
		7,
		80925
	],
	"./fi/index.js.flow": [
		35313,
		1,
		35313
	],
	"./fi/package": [
		10482,
		3,
		10482
	],
	"./fi/package.json": [
		10482,
		3,
		10482
	],
	"./fr": [
		72307,
		9,
		72307
	],
	"./fr-CA": [
		84931,
		9,
		84931
	],
	"./fr-CA/": [
		84931,
		9,
		84931
	],
	"./fr-CA/_lib/formatLong": [
		11565,
		7,
		11565
	],
	"./fr-CA/_lib/formatLong/": [
		11565,
		7,
		11565
	],
	"./fr-CA/_lib/formatLong/index": [
		11565,
		7,
		11565
	],
	"./fr-CA/_lib/formatLong/index.js": [
		11565,
		7,
		11565
	],
	"./fr-CA/index": [
		26364,
		7,
		26364
	],
	"./fr-CA/index.d": [
		68054,
		9,
		68054
	],
	"./fr-CA/index.d.ts": [
		68054,
		9,
		68054
	],
	"./fr-CA/index.js": [
		26364,
		7,
		26364
	],
	"./fr-CA/index.js.flow": [
		14097,
		1,
		14097
	],
	"./fr-CA/package": [
		29653,
		3,
		29653
	],
	"./fr-CA/package.json": [
		29653,
		3,
		29653
	],
	"./fr-CH": [
		82391,
		9,
		82391
	],
	"./fr-CH/": [
		82391,
		9,
		82391
	],
	"./fr-CH/_lib/formatLong": [
		73291,
		7,
		73291
	],
	"./fr-CH/_lib/formatLong/": [
		73291,
		7,
		73291
	],
	"./fr-CH/_lib/formatLong/index": [
		73291,
		7,
		73291
	],
	"./fr-CH/_lib/formatLong/index.js": [
		73291,
		7,
		73291
	],
	"./fr-CH/_lib/formatRelative": [
		4349,
		7,
		4349
	],
	"./fr-CH/_lib/formatRelative/": [
		4349,
		7,
		4349
	],
	"./fr-CH/_lib/formatRelative/index": [
		4349,
		7,
		4349
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		4349,
		7,
		4349
	],
	"./fr-CH/index": [
		96546,
		7,
		96546
	],
	"./fr-CH/index.d": [
		25294,
		9,
		25294
	],
	"./fr-CH/index.d.ts": [
		25294,
		9,
		25294
	],
	"./fr-CH/index.js": [
		96546,
		7,
		96546
	],
	"./fr-CH/index.js.flow": [
		20241,
		1,
		20241
	],
	"./fr-CH/package": [
		81308,
		3,
		43141
	],
	"./fr-CH/package.json": [
		81308,
		3,
		43141
	],
	"./fr/": [
		72307,
		9,
		72307
	],
	"./fr/_lib/formatDistance": [
		92366,
		7,
		92366
	],
	"./fr/_lib/formatDistance/": [
		92366,
		7,
		92366
	],
	"./fr/_lib/formatDistance/index": [
		92366,
		7,
		92366
	],
	"./fr/_lib/formatDistance/index.js": [
		92366,
		7,
		92366
	],
	"./fr/_lib/formatLong": [
		85358,
		7,
		85358
	],
	"./fr/_lib/formatLong/": [
		85358,
		7,
		85358
	],
	"./fr/_lib/formatLong/index": [
		85358,
		7,
		85358
	],
	"./fr/_lib/formatLong/index.js": [
		85358,
		7,
		85358
	],
	"./fr/_lib/formatRelative": [
		31479,
		7,
		31479
	],
	"./fr/_lib/formatRelative/": [
		31479,
		7,
		31479
	],
	"./fr/_lib/formatRelative/index": [
		31479,
		7,
		31479
	],
	"./fr/_lib/formatRelative/index.js": [
		31479,
		7,
		31479
	],
	"./fr/_lib/localize": [
		77030,
		7,
		77030
	],
	"./fr/_lib/localize/": [
		77030,
		7,
		77030
	],
	"./fr/_lib/localize/index": [
		77030,
		7,
		77030
	],
	"./fr/_lib/localize/index.js": [
		77030,
		7,
		77030
	],
	"./fr/_lib/match": [
		19104,
		7,
		19104
	],
	"./fr/_lib/match/": [
		19104,
		7,
		19104
	],
	"./fr/_lib/match/index": [
		19104,
		7,
		19104
	],
	"./fr/_lib/match/index.js": [
		19104,
		7,
		19104
	],
	"./fr/index": [
		31790,
		7,
		31790
	],
	"./fr/index.d": [
		13009,
		9,
		13009
	],
	"./fr/index.d.ts": [
		13009,
		9,
		13009
	],
	"./fr/index.js": [
		31790,
		7,
		31790
	],
	"./fr/index.js.flow": [
		98437,
		1,
		98437
	],
	"./fr/package": [
		80704,
		3,
		80704
	],
	"./fr/package.json": [
		80704,
		3,
		80704
	],
	"./fy": [
		27982,
		9,
		27982
	],
	"./fy/": [
		27982,
		9,
		27982
	],
	"./fy/_lib/formatDistance": [
		65058,
		7,
		65058
	],
	"./fy/_lib/formatDistance/": [
		65058,
		7,
		65058
	],
	"./fy/_lib/formatDistance/index": [
		65058,
		7,
		65058
	],
	"./fy/_lib/formatDistance/index.js": [
		65058,
		7,
		65058
	],
	"./fy/_lib/formatLong": [
		81256,
		7,
		81256
	],
	"./fy/_lib/formatLong/": [
		81256,
		7,
		81256
	],
	"./fy/_lib/formatLong/index": [
		81256,
		7,
		81256
	],
	"./fy/_lib/formatLong/index.js": [
		81256,
		7,
		81256
	],
	"./fy/_lib/formatRelative": [
		94526,
		7,
		94526
	],
	"./fy/_lib/formatRelative/": [
		94526,
		7,
		94526
	],
	"./fy/_lib/formatRelative/index": [
		94526,
		7,
		94526
	],
	"./fy/_lib/formatRelative/index.js": [
		94526,
		7,
		94526
	],
	"./fy/_lib/localize": [
		38309,
		7,
		38309
	],
	"./fy/_lib/localize/": [
		38309,
		7,
		38309
	],
	"./fy/_lib/localize/index": [
		38309,
		7,
		38309
	],
	"./fy/_lib/localize/index.js": [
		38309,
		7,
		38309
	],
	"./fy/_lib/match": [
		62638,
		7,
		62638
	],
	"./fy/_lib/match/": [
		62638,
		7,
		62638
	],
	"./fy/_lib/match/index": [
		62638,
		7,
		62638
	],
	"./fy/_lib/match/index.js": [
		62638,
		7,
		62638
	],
	"./fy/index": [
		2617,
		7,
		2617
	],
	"./fy/index.d": [
		97505,
		9,
		97505
	],
	"./fy/index.d.ts": [
		97505,
		9,
		97505
	],
	"./fy/index.js": [
		2617,
		7,
		2617
	],
	"./fy/index.js.flow": [
		62979,
		1,
		62979
	],
	"./fy/package": [
		64571,
		3,
		64571
	],
	"./fy/package.json": [
		64571,
		3,
		64571
	],
	"./gd": [
		30614,
		9,
		30614
	],
	"./gd/": [
		30614,
		9,
		30614
	],
	"./gd/_lib/formatDistance": [
		63931,
		7,
		63931
	],
	"./gd/_lib/formatDistance/": [
		63931,
		7,
		63931
	],
	"./gd/_lib/formatDistance/index": [
		63931,
		7,
		63931
	],
	"./gd/_lib/formatDistance/index.js": [
		63931,
		7,
		63931
	],
	"./gd/_lib/formatLong": [
		61123,
		7,
		61123
	],
	"./gd/_lib/formatLong/": [
		61123,
		7,
		61123
	],
	"./gd/_lib/formatLong/index": [
		61123,
		7,
		61123
	],
	"./gd/_lib/formatLong/index.js": [
		61123,
		7,
		61123
	],
	"./gd/_lib/formatRelative": [
		86033,
		7,
		86033
	],
	"./gd/_lib/formatRelative/": [
		86033,
		7,
		86033
	],
	"./gd/_lib/formatRelative/index": [
		86033,
		7,
		86033
	],
	"./gd/_lib/formatRelative/index.js": [
		86033,
		7,
		86033
	],
	"./gd/_lib/localize": [
		3863,
		7,
		3863
	],
	"./gd/_lib/localize/": [
		3863,
		7,
		3863
	],
	"./gd/_lib/localize/index": [
		3863,
		7,
		3863
	],
	"./gd/_lib/localize/index.js": [
		3863,
		7,
		3863
	],
	"./gd/_lib/match": [
		91534,
		7,
		91534
	],
	"./gd/_lib/match/": [
		91534,
		7,
		91534
	],
	"./gd/_lib/match/index": [
		91534,
		7,
		91534
	],
	"./gd/_lib/match/index.js": [
		91534,
		7,
		91534
	],
	"./gd/index": [
		56382,
		7,
		56382
	],
	"./gd/index.d": [
		84117,
		9,
		84117
	],
	"./gd/index.d.ts": [
		84117,
		9,
		84117
	],
	"./gd/index.js": [
		56382,
		7,
		56382
	],
	"./gd/index.js.flow": [
		10637,
		1,
		10637
	],
	"./gd/package": [
		50530,
		3,
		50530
	],
	"./gd/package.json": [
		50530,
		3,
		50530
	],
	"./gl": [
		10062,
		9,
		10062
	],
	"./gl/": [
		10062,
		9,
		10062
	],
	"./gl/_lib/formatDistance": [
		1049,
		7,
		1049
	],
	"./gl/_lib/formatDistance/": [
		1049,
		7,
		1049
	],
	"./gl/_lib/formatDistance/index": [
		1049,
		7,
		1049
	],
	"./gl/_lib/formatDistance/index.js": [
		1049,
		7,
		1049
	],
	"./gl/_lib/formatLong": [
		51759,
		7,
		51759
	],
	"./gl/_lib/formatLong/": [
		51759,
		7,
		51759
	],
	"./gl/_lib/formatLong/index": [
		51759,
		7,
		51759
	],
	"./gl/_lib/formatLong/index.js": [
		51759,
		7,
		51759
	],
	"./gl/_lib/formatRelative": [
		25849,
		7,
		25849
	],
	"./gl/_lib/formatRelative/": [
		25849,
		7,
		25849
	],
	"./gl/_lib/formatRelative/index": [
		25849,
		7,
		25849
	],
	"./gl/_lib/formatRelative/index.js": [
		25849,
		7,
		25849
	],
	"./gl/_lib/localize": [
		70892,
		7,
		70892
	],
	"./gl/_lib/localize/": [
		70892,
		7,
		70892
	],
	"./gl/_lib/localize/index": [
		70892,
		7,
		70892
	],
	"./gl/_lib/localize/index.js": [
		70892,
		7,
		70892
	],
	"./gl/_lib/match": [
		20368,
		7,
		20368
	],
	"./gl/_lib/match/": [
		20368,
		7,
		20368
	],
	"./gl/_lib/match/index": [
		20368,
		7,
		20368
	],
	"./gl/_lib/match/index.js": [
		20368,
		7,
		20368
	],
	"./gl/index": [
		83103,
		7,
		83103
	],
	"./gl/index.d": [
		83275,
		9,
		83275
	],
	"./gl/index.d.ts": [
		83275,
		9,
		83275
	],
	"./gl/index.js": [
		83103,
		7,
		83103
	],
	"./gl/index.js.flow": [
		13021,
		1,
		13021
	],
	"./gl/package": [
		28553,
		3,
		28553
	],
	"./gl/package.json": [
		28553,
		3,
		28553
	],
	"./gu": [
		1779,
		9,
		1779
	],
	"./gu/": [
		1779,
		9,
		1779
	],
	"./gu/_lib/formatDistance": [
		70869,
		7,
		70869
	],
	"./gu/_lib/formatDistance/": [
		70869,
		7,
		70869
	],
	"./gu/_lib/formatDistance/index": [
		70869,
		7,
		70869
	],
	"./gu/_lib/formatDistance/index.js": [
		70869,
		7,
		70869
	],
	"./gu/_lib/formatLong": [
		70816,
		7,
		70816
	],
	"./gu/_lib/formatLong/": [
		70816,
		7,
		70816
	],
	"./gu/_lib/formatLong/index": [
		70816,
		7,
		70816
	],
	"./gu/_lib/formatLong/index.js": [
		70816,
		7,
		70816
	],
	"./gu/_lib/formatRelative": [
		63403,
		7,
		63403
	],
	"./gu/_lib/formatRelative/": [
		63403,
		7,
		63403
	],
	"./gu/_lib/formatRelative/index": [
		63403,
		7,
		63403
	],
	"./gu/_lib/formatRelative/index.js": [
		63403,
		7,
		63403
	],
	"./gu/_lib/localize": [
		30412,
		7,
		30412
	],
	"./gu/_lib/localize/": [
		30412,
		7,
		30412
	],
	"./gu/_lib/localize/index": [
		30412,
		7,
		30412
	],
	"./gu/_lib/localize/index.js": [
		30412,
		7,
		30412
	],
	"./gu/_lib/match": [
		27840,
		7,
		27840
	],
	"./gu/_lib/match/": [
		27840,
		7,
		27840
	],
	"./gu/_lib/match/index": [
		27840,
		7,
		27840
	],
	"./gu/_lib/match/index.js": [
		27840,
		7,
		27840
	],
	"./gu/index": [
		99567,
		7,
		99567
	],
	"./gu/index.d": [
		67213,
		9,
		67213
	],
	"./gu/index.d.ts": [
		67213,
		9,
		67213
	],
	"./gu/index.js": [
		99567,
		7,
		99567
	],
	"./gu/index.js.flow": [
		42238,
		1,
		42238
	],
	"./gu/package": [
		20152,
		3,
		20152
	],
	"./gu/package.json": [
		20152,
		3,
		20152
	],
	"./he": [
		75321,
		9,
		75321
	],
	"./he/": [
		75321,
		9,
		75321
	],
	"./he/_lib/formatDistance": [
		40776,
		7,
		40776
	],
	"./he/_lib/formatDistance/": [
		40776,
		7,
		40776
	],
	"./he/_lib/formatDistance/index": [
		40776,
		7,
		40776
	],
	"./he/_lib/formatDistance/index.js": [
		40776,
		7,
		40776
	],
	"./he/_lib/formatLong": [
		18818,
		7,
		18818
	],
	"./he/_lib/formatLong/": [
		18818,
		7,
		18818
	],
	"./he/_lib/formatLong/index": [
		18818,
		7,
		18818
	],
	"./he/_lib/formatLong/index.js": [
		18818,
		7,
		18818
	],
	"./he/_lib/formatRelative": [
		39560,
		7,
		39560
	],
	"./he/_lib/formatRelative/": [
		39560,
		7,
		39560
	],
	"./he/_lib/formatRelative/index": [
		39560,
		7,
		39560
	],
	"./he/_lib/formatRelative/index.js": [
		39560,
		7,
		39560
	],
	"./he/_lib/localize": [
		7114,
		7,
		7114
	],
	"./he/_lib/localize/": [
		7114,
		7,
		7114
	],
	"./he/_lib/localize/index": [
		7114,
		7,
		7114
	],
	"./he/_lib/localize/index.js": [
		7114,
		7,
		7114
	],
	"./he/_lib/match": [
		31124,
		7,
		31124
	],
	"./he/_lib/match/": [
		31124,
		7,
		31124
	],
	"./he/_lib/match/index": [
		31124,
		7,
		31124
	],
	"./he/_lib/match/index.js": [
		31124,
		7,
		31124
	],
	"./he/index": [
		89661,
		7,
		89661
	],
	"./he/index.d": [
		7321,
		9,
		7321
	],
	"./he/index.d.ts": [
		7321,
		9,
		7321
	],
	"./he/index.js": [
		89661,
		7,
		89661
	],
	"./he/index.js.flow": [
		30171,
		1,
		30171
	],
	"./he/package": [
		68373,
		3,
		68373
	],
	"./he/package.json": [
		68373,
		3,
		68373
	],
	"./hi": [
		80180,
		9,
		80180
	],
	"./hi/": [
		80180,
		9,
		80180
	],
	"./hi/_lib/formatDistance": [
		10454,
		7,
		10454
	],
	"./hi/_lib/formatDistance/": [
		10454,
		7,
		10454
	],
	"./hi/_lib/formatDistance/index": [
		10454,
		7,
		10454
	],
	"./hi/_lib/formatDistance/index.js": [
		10454,
		7,
		10454
	],
	"./hi/_lib/formatLong": [
		22003,
		7,
		22003
	],
	"./hi/_lib/formatLong/": [
		22003,
		7,
		22003
	],
	"./hi/_lib/formatLong/index": [
		22003,
		7,
		22003
	],
	"./hi/_lib/formatLong/index.js": [
		22003,
		7,
		22003
	],
	"./hi/_lib/formatRelative": [
		91283,
		7,
		91283
	],
	"./hi/_lib/formatRelative/": [
		91283,
		7,
		91283
	],
	"./hi/_lib/formatRelative/index": [
		91283,
		7,
		91283
	],
	"./hi/_lib/formatRelative/index.js": [
		91283,
		7,
		91283
	],
	"./hi/_lib/localize": [
		4423,
		9,
		49277
	],
	"./hi/_lib/localize/": [
		4423,
		9,
		49277
	],
	"./hi/_lib/localize/index": [
		4423,
		9,
		49277
	],
	"./hi/_lib/localize/index.js": [
		4423,
		9,
		49277
	],
	"./hi/_lib/match": [
		2541,
		7,
		2541
	],
	"./hi/_lib/match/": [
		2541,
		7,
		2541
	],
	"./hi/_lib/match/index": [
		2541,
		7,
		2541
	],
	"./hi/_lib/match/index.js": [
		2541,
		7,
		2541
	],
	"./hi/index": [
		35598,
		7,
		35598
	],
	"./hi/index.d": [
		87113,
		9,
		87113
	],
	"./hi/index.d.ts": [
		87113,
		9,
		87113
	],
	"./hi/index.js": [
		35598,
		7,
		35598
	],
	"./hi/index.js.flow": [
		80998,
		1,
		80998
	],
	"./hi/package": [
		81117,
		3,
		81117
	],
	"./hi/package.json": [
		81117,
		3,
		81117
	],
	"./hr": [
		4561,
		9,
		4561
	],
	"./hr/": [
		4561,
		9,
		4561
	],
	"./hr/_lib/formatDistance": [
		94187,
		7,
		94187
	],
	"./hr/_lib/formatDistance/": [
		94187,
		7,
		94187
	],
	"./hr/_lib/formatDistance/index": [
		94187,
		7,
		94187
	],
	"./hr/_lib/formatDistance/index.js": [
		94187,
		7,
		94187
	],
	"./hr/_lib/formatLong": [
		79013,
		7,
		79013
	],
	"./hr/_lib/formatLong/": [
		79013,
		7,
		79013
	],
	"./hr/_lib/formatLong/index": [
		79013,
		7,
		79013
	],
	"./hr/_lib/formatLong/index.js": [
		79013,
		7,
		79013
	],
	"./hr/_lib/formatRelative": [
		44347,
		7,
		44347
	],
	"./hr/_lib/formatRelative/": [
		44347,
		7,
		44347
	],
	"./hr/_lib/formatRelative/index": [
		44347,
		7,
		44347
	],
	"./hr/_lib/formatRelative/index.js": [
		44347,
		7,
		44347
	],
	"./hr/_lib/localize": [
		83615,
		7,
		83615
	],
	"./hr/_lib/localize/": [
		83615,
		7,
		83615
	],
	"./hr/_lib/localize/index": [
		83615,
		7,
		83615
	],
	"./hr/_lib/localize/index.js": [
		83615,
		7,
		83615
	],
	"./hr/_lib/match": [
		48424,
		7,
		48424
	],
	"./hr/_lib/match/": [
		48424,
		7,
		48424
	],
	"./hr/_lib/match/index": [
		48424,
		7,
		48424
	],
	"./hr/_lib/match/index.js": [
		48424,
		7,
		48424
	],
	"./hr/index": [
		36774,
		7,
		36774
	],
	"./hr/index.d": [
		52822,
		9,
		52822
	],
	"./hr/index.d.ts": [
		52822,
		9,
		52822
	],
	"./hr/index.js": [
		36774,
		7,
		36774
	],
	"./hr/index.js.flow": [
		90030,
		1,
		90030
	],
	"./hr/package": [
		1813,
		3,
		1813
	],
	"./hr/package.json": [
		1813,
		3,
		1813
	],
	"./ht": [
		16408,
		9,
		16408
	],
	"./ht/": [
		16408,
		9,
		16408
	],
	"./ht/_lib/formatDistance": [
		54108,
		7,
		54108
	],
	"./ht/_lib/formatDistance/": [
		54108,
		7,
		54108
	],
	"./ht/_lib/formatDistance/index": [
		54108,
		7,
		54108
	],
	"./ht/_lib/formatDistance/index.js": [
		54108,
		7,
		54108
	],
	"./ht/_lib/formatLong": [
		4904,
		7,
		4904
	],
	"./ht/_lib/formatLong/": [
		4904,
		7,
		4904
	],
	"./ht/_lib/formatLong/index": [
		4904,
		7,
		4904
	],
	"./ht/_lib/formatLong/index.js": [
		4904,
		7,
		4904
	],
	"./ht/_lib/formatRelative": [
		25671,
		7,
		25671
	],
	"./ht/_lib/formatRelative/": [
		25671,
		7,
		25671
	],
	"./ht/_lib/formatRelative/index": [
		25671,
		7,
		25671
	],
	"./ht/_lib/formatRelative/index.js": [
		25671,
		7,
		25671
	],
	"./ht/_lib/localize": [
		80645,
		7,
		87087
	],
	"./ht/_lib/localize/": [
		80645,
		7,
		87087
	],
	"./ht/_lib/localize/index": [
		80645,
		7,
		87087
	],
	"./ht/_lib/localize/index.js": [
		80645,
		7,
		87087
	],
	"./ht/_lib/match": [
		59806,
		7,
		59806
	],
	"./ht/_lib/match/": [
		59806,
		7,
		59806
	],
	"./ht/_lib/match/index": [
		59806,
		7,
		59806
	],
	"./ht/_lib/match/index.js": [
		59806,
		7,
		59806
	],
	"./ht/index": [
		77243,
		7,
		77243
	],
	"./ht/index.d": [
		65022,
		9,
		65022
	],
	"./ht/index.d.ts": [
		65022,
		9,
		65022
	],
	"./ht/index.js": [
		77243,
		7,
		77243
	],
	"./ht/index.js.flow": [
		54199,
		1,
		54199
	],
	"./ht/package": [
		17188,
		3,
		17188
	],
	"./ht/package.json": [
		17188,
		3,
		17188
	],
	"./hu": [
		30905,
		9,
		30905
	],
	"./hu/": [
		30905,
		9,
		30905
	],
	"./hu/_lib/formatDistance": [
		1021,
		7,
		1021
	],
	"./hu/_lib/formatDistance/": [
		1021,
		7,
		1021
	],
	"./hu/_lib/formatDistance/index": [
		1021,
		7,
		1021
	],
	"./hu/_lib/formatDistance/index.js": [
		1021,
		7,
		1021
	],
	"./hu/_lib/formatLong": [
		46699,
		7,
		46699
	],
	"./hu/_lib/formatLong/": [
		46699,
		7,
		46699
	],
	"./hu/_lib/formatLong/index": [
		46699,
		7,
		46699
	],
	"./hu/_lib/formatLong/index.js": [
		46699,
		7,
		46699
	],
	"./hu/_lib/formatRelative": [
		67163,
		7,
		67163
	],
	"./hu/_lib/formatRelative/": [
		67163,
		7,
		67163
	],
	"./hu/_lib/formatRelative/index": [
		67163,
		7,
		67163
	],
	"./hu/_lib/formatRelative/index.js": [
		67163,
		7,
		67163
	],
	"./hu/_lib/localize": [
		68367,
		7,
		68367
	],
	"./hu/_lib/localize/": [
		68367,
		7,
		68367
	],
	"./hu/_lib/localize/index": [
		68367,
		7,
		68367
	],
	"./hu/_lib/localize/index.js": [
		68367,
		7,
		68367
	],
	"./hu/_lib/match": [
		87475,
		7,
		87475
	],
	"./hu/_lib/match/": [
		87475,
		7,
		87475
	],
	"./hu/_lib/match/index": [
		87475,
		7,
		87475
	],
	"./hu/_lib/match/index.js": [
		87475,
		7,
		87475
	],
	"./hu/index": [
		94101,
		7,
		94101
	],
	"./hu/index.d": [
		26085,
		9,
		26085
	],
	"./hu/index.d.ts": [
		26085,
		9,
		26085
	],
	"./hu/index.js": [
		94101,
		7,
		94101
	],
	"./hu/index.js.flow": [
		92172,
		1,
		92172
	],
	"./hu/package": [
		3630,
		3,
		3630
	],
	"./hu/package.json": [
		3630,
		3,
		3630
	],
	"./hy": [
		84833,
		9,
		84833
	],
	"./hy/": [
		84833,
		9,
		84833
	],
	"./hy/_lib/formatDistance": [
		70470,
		7,
		70470
	],
	"./hy/_lib/formatDistance/": [
		70470,
		7,
		70470
	],
	"./hy/_lib/formatDistance/index": [
		70470,
		7,
		70470
	],
	"./hy/_lib/formatDistance/index.js": [
		70470,
		7,
		70470
	],
	"./hy/_lib/formatLong": [
		11645,
		7,
		11645
	],
	"./hy/_lib/formatLong/": [
		11645,
		7,
		11645
	],
	"./hy/_lib/formatLong/index": [
		11645,
		7,
		11645
	],
	"./hy/_lib/formatLong/index.js": [
		11645,
		7,
		11645
	],
	"./hy/_lib/formatRelative": [
		32147,
		7,
		32147
	],
	"./hy/_lib/formatRelative/": [
		32147,
		7,
		32147
	],
	"./hy/_lib/formatRelative/index": [
		32147,
		7,
		32147
	],
	"./hy/_lib/formatRelative/index.js": [
		32147,
		7,
		32147
	],
	"./hy/_lib/localize": [
		38937,
		7,
		38937
	],
	"./hy/_lib/localize/": [
		38937,
		7,
		38937
	],
	"./hy/_lib/localize/index": [
		38937,
		7,
		38937
	],
	"./hy/_lib/localize/index.js": [
		38937,
		7,
		38937
	],
	"./hy/_lib/match": [
		2032,
		7,
		2032
	],
	"./hy/_lib/match/": [
		2032,
		7,
		2032
	],
	"./hy/_lib/match/index": [
		2032,
		7,
		2032
	],
	"./hy/_lib/match/index.js": [
		2032,
		7,
		2032
	],
	"./hy/index": [
		64085,
		7,
		64085
	],
	"./hy/index.d": [
		33873,
		9,
		33873
	],
	"./hy/index.d.ts": [
		33873,
		9,
		33873
	],
	"./hy/index.js": [
		64085,
		7,
		64085
	],
	"./hy/index.js.flow": [
		56826,
		1,
		56826
	],
	"./hy/package": [
		47638,
		3,
		47638
	],
	"./hy/package.json": [
		47638,
		3,
		47638
	],
	"./id": [
		83791,
		9,
		83791
	],
	"./id/": [
		83791,
		9,
		83791
	],
	"./id/_lib/formatDistance": [
		91545,
		7,
		91545
	],
	"./id/_lib/formatDistance/": [
		91545,
		7,
		91545
	],
	"./id/_lib/formatDistance/index": [
		91545,
		7,
		91545
	],
	"./id/_lib/formatDistance/index.js": [
		91545,
		7,
		91545
	],
	"./id/_lib/formatLong": [
		28124,
		7,
		28124
	],
	"./id/_lib/formatLong/": [
		28124,
		7,
		28124
	],
	"./id/_lib/formatLong/index": [
		28124,
		7,
		28124
	],
	"./id/_lib/formatLong/index.js": [
		28124,
		7,
		28124
	],
	"./id/_lib/formatRelative": [
		64066,
		7,
		64066
	],
	"./id/_lib/formatRelative/": [
		64066,
		7,
		64066
	],
	"./id/_lib/formatRelative/index": [
		64066,
		7,
		64066
	],
	"./id/_lib/formatRelative/index.js": [
		64066,
		7,
		64066
	],
	"./id/_lib/localize": [
		54159,
		7,
		54159
	],
	"./id/_lib/localize/": [
		54159,
		7,
		54159
	],
	"./id/_lib/localize/index": [
		54159,
		7,
		54159
	],
	"./id/_lib/localize/index.js": [
		54159,
		7,
		54159
	],
	"./id/_lib/match": [
		93031,
		7,
		93031
	],
	"./id/_lib/match/": [
		93031,
		7,
		93031
	],
	"./id/_lib/match/index": [
		93031,
		7,
		93031
	],
	"./id/_lib/match/index.js": [
		93031,
		7,
		93031
	],
	"./id/index": [
		54473,
		7,
		54473
	],
	"./id/index.d": [
		13914,
		9,
		13914
	],
	"./id/index.d.ts": [
		13914,
		9,
		13914
	],
	"./id/index.js": [
		54473,
		7,
		54473
	],
	"./id/index.js.flow": [
		1419,
		1,
		1419
	],
	"./id/package": [
		81037,
		3,
		13106
	],
	"./id/package.json": [
		81037,
		3,
		13106
	],
	"./index": [
		51529,
		9,
		57223,
		92982,
		83350,
		20379,
		20511,
		27773,
		84588,
		70905,
		51529
	],
	"./index.js": [
		51529,
		9,
		57223,
		92982,
		83350,
		20379,
		20511,
		27773,
		84588,
		70905,
		51529
	],
	"./index.js.flow": [
		20636,
		1,
		20636
	],
	"./is": [
		76191,
		9,
		76191
	],
	"./is/": [
		76191,
		9,
		76191
	],
	"./is/_lib/formatDistance": [
		63213,
		7,
		63213
	],
	"./is/_lib/formatDistance/": [
		63213,
		7,
		63213
	],
	"./is/_lib/formatDistance/index": [
		63213,
		7,
		63213
	],
	"./is/_lib/formatDistance/index.js": [
		63213,
		7,
		63213
	],
	"./is/_lib/formatLong": [
		91517,
		7,
		91517
	],
	"./is/_lib/formatLong/": [
		91517,
		7,
		91517
	],
	"./is/_lib/formatLong/index": [
		91517,
		7,
		91517
	],
	"./is/_lib/formatLong/index.js": [
		91517,
		7,
		91517
	],
	"./is/_lib/formatRelative": [
		5819,
		7,
		5819
	],
	"./is/_lib/formatRelative/": [
		5819,
		7,
		5819
	],
	"./is/_lib/formatRelative/index": [
		5819,
		7,
		5819
	],
	"./is/_lib/formatRelative/index.js": [
		5819,
		7,
		5819
	],
	"./is/_lib/localize": [
		50456,
		7,
		50456
	],
	"./is/_lib/localize/": [
		50456,
		7,
		50456
	],
	"./is/_lib/localize/index": [
		50456,
		7,
		50456
	],
	"./is/_lib/localize/index.js": [
		50456,
		7,
		50456
	],
	"./is/_lib/match": [
		83813,
		7,
		83813
	],
	"./is/_lib/match/": [
		83813,
		7,
		83813
	],
	"./is/_lib/match/index": [
		83813,
		7,
		83813
	],
	"./is/_lib/match/index.js": [
		83813,
		7,
		83813
	],
	"./is/index": [
		69787,
		7,
		69787
	],
	"./is/index.d": [
		30954,
		9,
		30954
	],
	"./is/index.d.ts": [
		30954,
		9,
		30954
	],
	"./is/index.js": [
		69787,
		7,
		69787
	],
	"./is/index.js.flow": [
		26721,
		1,
		8914
	],
	"./is/package": [
		71136,
		3,
		71136
	],
	"./is/package.json": [
		71136,
		3,
		71136
	],
	"./it": [
		73983,
		9,
		73983
	],
	"./it-CH": [
		2116,
		9,
		2116
	],
	"./it-CH/": [
		2116,
		9,
		2116
	],
	"./it-CH/_lib/formatLong": [
		4879,
		7,
		4879
	],
	"./it-CH/_lib/formatLong/": [
		4879,
		7,
		4879
	],
	"./it-CH/_lib/formatLong/index": [
		4879,
		7,
		4879
	],
	"./it-CH/_lib/formatLong/index.js": [
		4879,
		7,
		4879
	],
	"./it-CH/index": [
		56374,
		7,
		56374
	],
	"./it-CH/index.d": [
		36787,
		9,
		36787
	],
	"./it-CH/index.d.ts": [
		36787,
		9,
		36787
	],
	"./it-CH/index.js": [
		56374,
		7,
		56374
	],
	"./it-CH/index.js.flow": [
		93421,
		1,
		93421
	],
	"./it-CH/package": [
		24839,
		3,
		24839
	],
	"./it-CH/package.json": [
		24839,
		3,
		24839
	],
	"./it/": [
		73983,
		9,
		73983
	],
	"./it/_lib/formatDistance": [
		65014,
		7,
		65014
	],
	"./it/_lib/formatDistance/": [
		65014,
		7,
		65014
	],
	"./it/_lib/formatDistance/index": [
		65014,
		7,
		65014
	],
	"./it/_lib/formatDistance/index.js": [
		65014,
		7,
		65014
	],
	"./it/_lib/formatLong": [
		46843,
		7,
		46843
	],
	"./it/_lib/formatLong/": [
		46843,
		7,
		46843
	],
	"./it/_lib/formatLong/index": [
		46843,
		7,
		46843
	],
	"./it/_lib/formatLong/index.js": [
		46843,
		7,
		46843
	],
	"./it/_lib/formatRelative": [
		54325,
		7,
		54325
	],
	"./it/_lib/formatRelative/": [
		54325,
		7,
		54325
	],
	"./it/_lib/formatRelative/index": [
		54325,
		7,
		54325
	],
	"./it/_lib/formatRelative/index.js": [
		54325,
		7,
		54325
	],
	"./it/_lib/localize": [
		95652,
		7,
		95652
	],
	"./it/_lib/localize/": [
		95652,
		7,
		95652
	],
	"./it/_lib/localize/index": [
		95652,
		7,
		95652
	],
	"./it/_lib/localize/index.js": [
		95652,
		7,
		95652
	],
	"./it/_lib/match": [
		4476,
		7,
		4476
	],
	"./it/_lib/match/": [
		4476,
		7,
		4476
	],
	"./it/_lib/match/index": [
		4476,
		7,
		4476
	],
	"./it/_lib/match/index.js": [
		4476,
		7,
		4476
	],
	"./it/index": [
		70556,
		7,
		70556
	],
	"./it/index.d": [
		90330,
		9,
		90330
	],
	"./it/index.d.ts": [
		90330,
		9,
		90330
	],
	"./it/index.js": [
		70556,
		7,
		70556
	],
	"./it/index.js.flow": [
		1916,
		1,
		1916
	],
	"./it/package": [
		44570,
		3,
		44570
	],
	"./it/package.json": [
		44570,
		3,
		44570
	],
	"./ja": [
		65213,
		9,
		65213
	],
	"./ja-Hira": [
		23386,
		9,
		23386
	],
	"./ja-Hira/": [
		23386,
		9,
		23386
	],
	"./ja-Hira/_lib/formatDistance": [
		71939,
		7,
		71939
	],
	"./ja-Hira/_lib/formatDistance/": [
		71939,
		7,
		71939
	],
	"./ja-Hira/_lib/formatDistance/index": [
		71939,
		7,
		71939
	],
	"./ja-Hira/_lib/formatDistance/index.js": [
		71939,
		7,
		71939
	],
	"./ja-Hira/_lib/formatLong": [
		3497,
		7,
		3497
	],
	"./ja-Hira/_lib/formatLong/": [
		3497,
		7,
		3497
	],
	"./ja-Hira/_lib/formatLong/index": [
		3497,
		7,
		3497
	],
	"./ja-Hira/_lib/formatLong/index.js": [
		3497,
		7,
		3497
	],
	"./ja-Hira/_lib/formatRelative": [
		98957,
		7,
		98957
	],
	"./ja-Hira/_lib/formatRelative/": [
		98957,
		7,
		98957
	],
	"./ja-Hira/_lib/formatRelative/index": [
		98957,
		7,
		98957
	],
	"./ja-Hira/_lib/formatRelative/index.js": [
		98957,
		7,
		98957
	],
	"./ja-Hira/_lib/localize": [
		49519,
		7,
		49519
	],
	"./ja-Hira/_lib/localize/": [
		49519,
		7,
		49519
	],
	"./ja-Hira/_lib/localize/index": [
		49519,
		7,
		49519
	],
	"./ja-Hira/_lib/localize/index.js": [
		49519,
		7,
		49519
	],
	"./ja-Hira/_lib/match": [
		47758,
		7,
		47758
	],
	"./ja-Hira/_lib/match/": [
		47758,
		7,
		47758
	],
	"./ja-Hira/_lib/match/index": [
		47758,
		7,
		47758
	],
	"./ja-Hira/_lib/match/index.js": [
		47758,
		7,
		47758
	],
	"./ja-Hira/index": [
		84460,
		7,
		84460
	],
	"./ja-Hira/index.d": [
		1454,
		9,
		1454
	],
	"./ja-Hira/index.d.ts": [
		1454,
		9,
		1454
	],
	"./ja-Hira/index.js": [
		84460,
		7,
		84460
	],
	"./ja-Hira/index.js.flow": [
		44145,
		1,
		44145
	],
	"./ja-Hira/package": [
		7964,
		3,
		7964
	],
	"./ja-Hira/package.json": [
		7964,
		3,
		7964
	],
	"./ja/": [
		65213,
		9,
		65213
	],
	"./ja/_lib/formatDistance": [
		75639,
		7,
		75639
	],
	"./ja/_lib/formatDistance/": [
		75639,
		7,
		75639
	],
	"./ja/_lib/formatDistance/index": [
		75639,
		7,
		75639
	],
	"./ja/_lib/formatDistance/index.js": [
		75639,
		7,
		75639
	],
	"./ja/_lib/formatLong": [
		89790,
		7,
		89790
	],
	"./ja/_lib/formatLong/": [
		89790,
		7,
		89790
	],
	"./ja/_lib/formatLong/index": [
		89790,
		7,
		89790
	],
	"./ja/_lib/formatLong/index.js": [
		89790,
		7,
		89790
	],
	"./ja/_lib/formatRelative": [
		22015,
		7,
		22015
	],
	"./ja/_lib/formatRelative/": [
		22015,
		7,
		22015
	],
	"./ja/_lib/formatRelative/index": [
		22015,
		7,
		22015
	],
	"./ja/_lib/formatRelative/index.js": [
		22015,
		7,
		22015
	],
	"./ja/_lib/localize": [
		85448,
		7,
		85448
	],
	"./ja/_lib/localize/": [
		85448,
		7,
		85448
	],
	"./ja/_lib/localize/index": [
		85448,
		7,
		85448
	],
	"./ja/_lib/localize/index.js": [
		85448,
		7,
		85448
	],
	"./ja/_lib/match": [
		91809,
		7,
		91809
	],
	"./ja/_lib/match/": [
		91809,
		7,
		91809
	],
	"./ja/_lib/match/index": [
		91809,
		7,
		91809
	],
	"./ja/_lib/match/index.js": [
		91809,
		7,
		91809
	],
	"./ja/index": [
		88116,
		7,
		88116
	],
	"./ja/index.d": [
		66610,
		9,
		66610
	],
	"./ja/index.d.ts": [
		66610,
		9,
		66610
	],
	"./ja/index.js": [
		88116,
		7,
		88116
	],
	"./ja/index.js.flow": [
		46811,
		1,
		46811
	],
	"./ja/package": [
		89712,
		3,
		89712
	],
	"./ja/package.json": [
		89712,
		3,
		89712
	],
	"./ka": [
		56322,
		9,
		56322
	],
	"./ka/": [
		56322,
		9,
		56322
	],
	"./ka/_lib/formatDistance": [
		35693,
		7,
		35693
	],
	"./ka/_lib/formatDistance/": [
		35693,
		7,
		35693
	],
	"./ka/_lib/formatDistance/index": [
		35693,
		7,
		35693
	],
	"./ka/_lib/formatDistance/index.js": [
		35693,
		7,
		35693
	],
	"./ka/_lib/formatLong": [
		51422,
		7,
		51422
	],
	"./ka/_lib/formatLong/": [
		51422,
		7,
		51422
	],
	"./ka/_lib/formatLong/index": [
		51422,
		7,
		51422
	],
	"./ka/_lib/formatLong/index.js": [
		51422,
		7,
		51422
	],
	"./ka/_lib/formatRelative": [
		334,
		7,
		334
	],
	"./ka/_lib/formatRelative/": [
		334,
		7,
		334
	],
	"./ka/_lib/formatRelative/index": [
		334,
		7,
		334
	],
	"./ka/_lib/formatRelative/index.js": [
		334,
		7,
		334
	],
	"./ka/_lib/localize": [
		52430,
		7,
		52430
	],
	"./ka/_lib/localize/": [
		52430,
		7,
		52430
	],
	"./ka/_lib/localize/index": [
		52430,
		7,
		52430
	],
	"./ka/_lib/localize/index.js": [
		52430,
		7,
		52430
	],
	"./ka/_lib/match": [
		98566,
		7,
		98566
	],
	"./ka/_lib/match/": [
		98566,
		7,
		98566
	],
	"./ka/_lib/match/index": [
		98566,
		7,
		98566
	],
	"./ka/_lib/match/index.js": [
		98566,
		7,
		98566
	],
	"./ka/index": [
		32436,
		7,
		32436
	],
	"./ka/index.d": [
		71559,
		9,
		71559
	],
	"./ka/index.d.ts": [
		71559,
		9,
		71559
	],
	"./ka/index.js": [
		32436,
		7,
		32436
	],
	"./ka/index.js.flow": [
		93894,
		1,
		93894
	],
	"./ka/package": [
		90933,
		3,
		90933
	],
	"./ka/package.json": [
		90933,
		3,
		90933
	],
	"./kk": [
		56583,
		9,
		56583
	],
	"./kk/": [
		56583,
		9,
		56583
	],
	"./kk/_lib/formatDistance": [
		67695,
		7,
		67695
	],
	"./kk/_lib/formatDistance/": [
		67695,
		7,
		67695
	],
	"./kk/_lib/formatDistance/index": [
		67695,
		7,
		67695
	],
	"./kk/_lib/formatDistance/index.js": [
		67695,
		7,
		67695
	],
	"./kk/_lib/formatLong": [
		39911,
		7,
		39911
	],
	"./kk/_lib/formatLong/": [
		39911,
		7,
		39911
	],
	"./kk/_lib/formatLong/index": [
		39911,
		7,
		39911
	],
	"./kk/_lib/formatLong/index.js": [
		39911,
		7,
		39911
	],
	"./kk/_lib/formatRelative": [
		9922,
		7,
		9922
	],
	"./kk/_lib/formatRelative/": [
		9922,
		7,
		9922
	],
	"./kk/_lib/formatRelative/index": [
		9922,
		7,
		9922
	],
	"./kk/_lib/formatRelative/index.js": [
		9922,
		7,
		9922
	],
	"./kk/_lib/localize": [
		94718,
		7,
		94718
	],
	"./kk/_lib/localize/": [
		94718,
		7,
		94718
	],
	"./kk/_lib/localize/index": [
		94718,
		7,
		94718
	],
	"./kk/_lib/localize/index.js": [
		94718,
		7,
		94718
	],
	"./kk/_lib/match": [
		88699,
		7,
		88699
	],
	"./kk/_lib/match/": [
		88699,
		7,
		88699
	],
	"./kk/_lib/match/index": [
		88699,
		7,
		88699
	],
	"./kk/_lib/match/index.js": [
		88699,
		7,
		88699
	],
	"./kk/index": [
		70905,
		7,
		70905,
		16246
	],
	"./kk/index.d": [
		56168,
		9,
		56168
	],
	"./kk/index.d.ts": [
		56168,
		9,
		56168
	],
	"./kk/index.js": [
		70905,
		7,
		70905,
		16246
	],
	"./kk/index.js.flow": [
		24296,
		1,
		24296
	],
	"./kk/package": [
		37617,
		3,
		37617
	],
	"./kk/package.json": [
		37617,
		3,
		37617
	],
	"./km": [
		68779,
		9,
		68779
	],
	"./km/": [
		68779,
		9,
		68779
	],
	"./km/_lib/formatDistance": [
		76236,
		7,
		76236
	],
	"./km/_lib/formatDistance/": [
		76236,
		7,
		76236
	],
	"./km/_lib/formatDistance/index": [
		76236,
		7,
		76236
	],
	"./km/_lib/formatDistance/index.js": [
		76236,
		7,
		76236
	],
	"./km/_lib/formatLong": [
		98363,
		7,
		98363
	],
	"./km/_lib/formatLong/": [
		98363,
		7,
		98363
	],
	"./km/_lib/formatLong/index": [
		98363,
		7,
		98363
	],
	"./km/_lib/formatLong/index.js": [
		98363,
		7,
		98363
	],
	"./km/_lib/formatRelative": [
		32704,
		7,
		32704
	],
	"./km/_lib/formatRelative/": [
		32704,
		7,
		32704
	],
	"./km/_lib/formatRelative/index": [
		32704,
		7,
		32704
	],
	"./km/_lib/formatRelative/index.js": [
		32704,
		7,
		32704
	],
	"./km/_lib/localize": [
		24551,
		7,
		24551
	],
	"./km/_lib/localize/": [
		24551,
		7,
		24551
	],
	"./km/_lib/localize/index": [
		24551,
		7,
		24551
	],
	"./km/_lib/localize/index.js": [
		24551,
		7,
		24551
	],
	"./km/_lib/match": [
		50670,
		7,
		50670
	],
	"./km/_lib/match/": [
		50670,
		7,
		50670
	],
	"./km/_lib/match/index": [
		50670,
		7,
		50670
	],
	"./km/_lib/match/index.js": [
		50670,
		7,
		50670
	],
	"./km/index": [
		85122,
		7,
		85122
	],
	"./km/index.d": [
		58387,
		9,
		58387
	],
	"./km/index.d.ts": [
		58387,
		9,
		58387
	],
	"./km/index.js": [
		85122,
		7,
		85122
	],
	"./km/index.js.flow": [
		56882,
		1,
		56882
	],
	"./km/package": [
		98300,
		3,
		98300
	],
	"./km/package.json": [
		98300,
		3,
		98300
	],
	"./kn": [
		893,
		9,
		893
	],
	"./kn/": [
		893,
		9,
		893
	],
	"./kn/_lib/formatDistance": [
		27828,
		7,
		27828
	],
	"./kn/_lib/formatDistance/": [
		27828,
		7,
		27828
	],
	"./kn/_lib/formatDistance/index": [
		27828,
		7,
		27828
	],
	"./kn/_lib/formatDistance/index.js": [
		27828,
		7,
		27828
	],
	"./kn/_lib/formatLong": [
		40170,
		7,
		40170
	],
	"./kn/_lib/formatLong/": [
		40170,
		7,
		40170
	],
	"./kn/_lib/formatLong/index": [
		40170,
		7,
		40170
	],
	"./kn/_lib/formatLong/index.js": [
		40170,
		7,
		40170
	],
	"./kn/_lib/formatRelative": [
		7635,
		7,
		7635
	],
	"./kn/_lib/formatRelative/": [
		7635,
		7,
		7635
	],
	"./kn/_lib/formatRelative/index": [
		7635,
		7,
		7635
	],
	"./kn/_lib/formatRelative/index.js": [
		7635,
		7,
		7635
	],
	"./kn/_lib/localize": [
		32362,
		7,
		32362
	],
	"./kn/_lib/localize/": [
		32362,
		7,
		32362
	],
	"./kn/_lib/localize/index": [
		32362,
		7,
		32362
	],
	"./kn/_lib/localize/index.js": [
		32362,
		7,
		32362
	],
	"./kn/_lib/match": [
		94938,
		7,
		94938
	],
	"./kn/_lib/match/": [
		94938,
		7,
		94938
	],
	"./kn/_lib/match/index": [
		94938,
		7,
		94938
	],
	"./kn/_lib/match/index.js": [
		94938,
		7,
		94938
	],
	"./kn/index": [
		23479,
		7,
		23479
	],
	"./kn/index.d": [
		69467,
		9,
		69467
	],
	"./kn/index.d.ts": [
		69467,
		9,
		69467
	],
	"./kn/index.js": [
		23479,
		7,
		23479
	],
	"./kn/index.js.flow": [
		90359,
		1,
		90359
	],
	"./kn/package": [
		38942,
		3,
		38942
	],
	"./kn/package.json": [
		38942,
		3,
		38942
	],
	"./ko": [
		96788,
		9,
		96788
	],
	"./ko/": [
		96788,
		9,
		96788
	],
	"./ko/_lib/formatDistance": [
		2071,
		7,
		2071
	],
	"./ko/_lib/formatDistance/": [
		2071,
		7,
		2071
	],
	"./ko/_lib/formatDistance/index": [
		2071,
		7,
		2071
	],
	"./ko/_lib/formatDistance/index.js": [
		2071,
		7,
		2071
	],
	"./ko/_lib/formatLong": [
		11961,
		7,
		11961
	],
	"./ko/_lib/formatLong/": [
		11961,
		7,
		11961
	],
	"./ko/_lib/formatLong/index": [
		11961,
		7,
		11961
	],
	"./ko/_lib/formatLong/index.js": [
		11961,
		7,
		11961
	],
	"./ko/_lib/formatRelative": [
		96114,
		7,
		96114
	],
	"./ko/_lib/formatRelative/": [
		96114,
		7,
		96114
	],
	"./ko/_lib/formatRelative/index": [
		96114,
		7,
		96114
	],
	"./ko/_lib/formatRelative/index.js": [
		96114,
		7,
		96114
	],
	"./ko/_lib/localize": [
		14199,
		7,
		14199
	],
	"./ko/_lib/localize/": [
		14199,
		7,
		14199
	],
	"./ko/_lib/localize/index": [
		14199,
		7,
		14199
	],
	"./ko/_lib/localize/index.js": [
		14199,
		7,
		14199
	],
	"./ko/_lib/match": [
		50238,
		7,
		50238
	],
	"./ko/_lib/match/": [
		50238,
		7,
		50238
	],
	"./ko/_lib/match/index": [
		50238,
		7,
		50238
	],
	"./ko/_lib/match/index.js": [
		50238,
		7,
		50238
	],
	"./ko/index": [
		51772,
		7,
		51772
	],
	"./ko/index.d": [
		85055,
		9,
		85055
	],
	"./ko/index.d.ts": [
		85055,
		9,
		85055
	],
	"./ko/index.js": [
		51772,
		7,
		51772
	],
	"./ko/index.js.flow": [
		38722,
		1,
		38722
	],
	"./ko/package": [
		54065,
		3,
		54065
	],
	"./ko/package.json": [
		54065,
		3,
		54065
	],
	"./lb": [
		72103,
		9,
		72103
	],
	"./lb/": [
		72103,
		9,
		72103
	],
	"./lb/_lib/formatDistance": [
		10678,
		7,
		10678
	],
	"./lb/_lib/formatDistance/": [
		10678,
		7,
		10678
	],
	"./lb/_lib/formatDistance/index": [
		10678,
		7,
		10678
	],
	"./lb/_lib/formatDistance/index.js": [
		10678,
		7,
		10678
	],
	"./lb/_lib/formatLong": [
		45595,
		7,
		45595
	],
	"./lb/_lib/formatLong/": [
		45595,
		7,
		45595
	],
	"./lb/_lib/formatLong/index": [
		45595,
		7,
		45595
	],
	"./lb/_lib/formatLong/index.js": [
		45595,
		7,
		45595
	],
	"./lb/_lib/formatRelative": [
		61633,
		7,
		61633
	],
	"./lb/_lib/formatRelative/": [
		61633,
		7,
		61633
	],
	"./lb/_lib/formatRelative/index": [
		61633,
		7,
		61633
	],
	"./lb/_lib/formatRelative/index.js": [
		61633,
		7,
		61633
	],
	"./lb/_lib/localize": [
		31048,
		7,
		31048
	],
	"./lb/_lib/localize/": [
		31048,
		7,
		31048
	],
	"./lb/_lib/localize/index": [
		31048,
		7,
		31048
	],
	"./lb/_lib/localize/index.js": [
		31048,
		7,
		31048
	],
	"./lb/_lib/match": [
		24028,
		7,
		24028
	],
	"./lb/_lib/match/": [
		24028,
		7,
		24028
	],
	"./lb/_lib/match/index": [
		24028,
		7,
		24028
	],
	"./lb/_lib/match/index.js": [
		24028,
		7,
		24028
	],
	"./lb/index": [
		71555,
		7,
		71555
	],
	"./lb/index.d": [
		76053,
		9,
		76053
	],
	"./lb/index.d.ts": [
		76053,
		9,
		76053
	],
	"./lb/index.js": [
		71555,
		7,
		71555
	],
	"./lb/index.js.flow": [
		36274,
		1,
		36274
	],
	"./lb/package": [
		63604,
		3,
		63604
	],
	"./lb/package.json": [
		63604,
		3,
		63604
	],
	"./lt": [
		87260,
		9,
		87260
	],
	"./lt/": [
		87260,
		9,
		87260
	],
	"./lt/_lib/formatDistance": [
		81410,
		7,
		81410
	],
	"./lt/_lib/formatDistance/": [
		81410,
		7,
		81410
	],
	"./lt/_lib/formatDistance/index": [
		81410,
		7,
		81410
	],
	"./lt/_lib/formatDistance/index.js": [
		81410,
		7,
		81410
	],
	"./lt/_lib/formatLong": [
		68306,
		7,
		68306
	],
	"./lt/_lib/formatLong/": [
		68306,
		7,
		68306
	],
	"./lt/_lib/formatLong/index": [
		68306,
		7,
		68306
	],
	"./lt/_lib/formatLong/index.js": [
		68306,
		7,
		68306
	],
	"./lt/_lib/formatRelative": [
		42974,
		7,
		42974
	],
	"./lt/_lib/formatRelative/": [
		42974,
		7,
		42974
	],
	"./lt/_lib/formatRelative/index": [
		42974,
		7,
		42974
	],
	"./lt/_lib/formatRelative/index.js": [
		42974,
		7,
		42974
	],
	"./lt/_lib/localize": [
		46622,
		7,
		46622
	],
	"./lt/_lib/localize/": [
		46622,
		7,
		46622
	],
	"./lt/_lib/localize/index": [
		46622,
		7,
		46622
	],
	"./lt/_lib/localize/index.js": [
		46622,
		7,
		46622
	],
	"./lt/_lib/match": [
		4854,
		7,
		4854
	],
	"./lt/_lib/match/": [
		4854,
		7,
		4854
	],
	"./lt/_lib/match/index": [
		4854,
		7,
		4854
	],
	"./lt/_lib/match/index.js": [
		4854,
		7,
		4854
	],
	"./lt/index": [
		54677,
		7,
		54677
	],
	"./lt/index.d": [
		62820,
		9,
		62820
	],
	"./lt/index.d.ts": [
		62820,
		9,
		62820
	],
	"./lt/index.js": [
		54677,
		7,
		54677
	],
	"./lt/index.js.flow": [
		38949,
		1,
		38949
	],
	"./lt/package": [
		82125,
		3,
		82125
	],
	"./lt/package.json": [
		82125,
		3,
		82125
	],
	"./lv": [
		90635,
		9,
		90635
	],
	"./lv/": [
		90635,
		9,
		90635
	],
	"./lv/_lib/formatDistance": [
		39377,
		7,
		39377
	],
	"./lv/_lib/formatDistance/": [
		39377,
		7,
		39377
	],
	"./lv/_lib/formatDistance/index": [
		39377,
		7,
		39377
	],
	"./lv/_lib/formatDistance/index.js": [
		39377,
		7,
		39377
	],
	"./lv/_lib/formatLong": [
		86766,
		7,
		86766
	],
	"./lv/_lib/formatLong/": [
		86766,
		7,
		86766
	],
	"./lv/_lib/formatLong/index": [
		86766,
		7,
		86766
	],
	"./lv/_lib/formatLong/index.js": [
		86766,
		7,
		86766
	],
	"./lv/_lib/formatRelative": [
		13829,
		7,
		13829
	],
	"./lv/_lib/formatRelative/": [
		13829,
		7,
		13829
	],
	"./lv/_lib/formatRelative/index": [
		13829,
		7,
		13829
	],
	"./lv/_lib/formatRelative/index.js": [
		13829,
		7,
		13829
	],
	"./lv/_lib/localize": [
		12325,
		7,
		12325
	],
	"./lv/_lib/localize/": [
		12325,
		7,
		12325
	],
	"./lv/_lib/localize/index": [
		12325,
		7,
		12325
	],
	"./lv/_lib/localize/index.js": [
		12325,
		7,
		12325
	],
	"./lv/_lib/match": [
		91408,
		7,
		91408
	],
	"./lv/_lib/match/": [
		91408,
		7,
		91408
	],
	"./lv/_lib/match/index": [
		91408,
		7,
		91408
	],
	"./lv/_lib/match/index.js": [
		91408,
		7,
		91408
	],
	"./lv/index": [
		30037,
		7,
		30037
	],
	"./lv/index.d": [
		56354,
		9,
		56354
	],
	"./lv/index.d.ts": [
		56354,
		9,
		56354
	],
	"./lv/index.js": [
		30037,
		7,
		30037
	],
	"./lv/index.js.flow": [
		36634,
		1,
		36634
	],
	"./lv/package": [
		88819,
		3,
		88819
	],
	"./lv/package.json": [
		88819,
		3,
		88819
	],
	"./mk": [
		25288,
		9,
		25288
	],
	"./mk/": [
		25288,
		9,
		25288
	],
	"./mk/_lib/formatDistance": [
		9695,
		7,
		9695
	],
	"./mk/_lib/formatDistance/": [
		9695,
		7,
		9695
	],
	"./mk/_lib/formatDistance/index": [
		9695,
		7,
		9695
	],
	"./mk/_lib/formatDistance/index.js": [
		9695,
		7,
		9695
	],
	"./mk/_lib/formatLong": [
		55109,
		7,
		55109
	],
	"./mk/_lib/formatLong/": [
		55109,
		7,
		55109
	],
	"./mk/_lib/formatLong/index": [
		55109,
		7,
		55109
	],
	"./mk/_lib/formatLong/index.js": [
		55109,
		7,
		55109
	],
	"./mk/_lib/formatRelative": [
		80269,
		7,
		80269
	],
	"./mk/_lib/formatRelative/": [
		80269,
		7,
		80269
	],
	"./mk/_lib/formatRelative/index": [
		80269,
		7,
		80269
	],
	"./mk/_lib/formatRelative/index.js": [
		80269,
		7,
		80269
	],
	"./mk/_lib/localize": [
		11003,
		7,
		11003
	],
	"./mk/_lib/localize/": [
		11003,
		7,
		11003
	],
	"./mk/_lib/localize/index": [
		11003,
		7,
		11003
	],
	"./mk/_lib/localize/index.js": [
		11003,
		7,
		11003
	],
	"./mk/_lib/match": [
		16739,
		7,
		16739
	],
	"./mk/_lib/match/": [
		16739,
		7,
		16739
	],
	"./mk/_lib/match/index": [
		16739,
		7,
		16739
	],
	"./mk/_lib/match/index.js": [
		16739,
		7,
		16739
	],
	"./mk/index": [
		76751,
		7,
		76751
	],
	"./mk/index.d": [
		49457,
		9,
		49457
	],
	"./mk/index.d.ts": [
		49457,
		9,
		49457
	],
	"./mk/index.js": [
		76751,
		7,
		76751
	],
	"./mk/index.js.flow": [
		77147,
		1,
		77147
	],
	"./mk/package": [
		77818,
		3,
		77818
	],
	"./mk/package.json": [
		77818,
		3,
		77818
	],
	"./mn": [
		97450,
		9,
		97450
	],
	"./mn/": [
		97450,
		9,
		97450
	],
	"./mn/_lib/formatDistance": [
		87153,
		7,
		87153
	],
	"./mn/_lib/formatDistance/": [
		87153,
		7,
		87153
	],
	"./mn/_lib/formatDistance/index": [
		87153,
		7,
		87153
	],
	"./mn/_lib/formatDistance/index.js": [
		87153,
		7,
		87153
	],
	"./mn/_lib/formatLong": [
		92492,
		7,
		92492
	],
	"./mn/_lib/formatLong/": [
		92492,
		7,
		92492
	],
	"./mn/_lib/formatLong/index": [
		92492,
		7,
		92492
	],
	"./mn/_lib/formatLong/index.js": [
		92492,
		7,
		92492
	],
	"./mn/_lib/formatRelative": [
		41942,
		7,
		41942
	],
	"./mn/_lib/formatRelative/": [
		41942,
		7,
		41942
	],
	"./mn/_lib/formatRelative/index": [
		41942,
		7,
		41942
	],
	"./mn/_lib/formatRelative/index.js": [
		41942,
		7,
		41942
	],
	"./mn/_lib/localize": [
		67271,
		7,
		67271
	],
	"./mn/_lib/localize/": [
		67271,
		7,
		67271
	],
	"./mn/_lib/localize/index": [
		67271,
		7,
		67271
	],
	"./mn/_lib/localize/index.js": [
		67271,
		7,
		67271
	],
	"./mn/_lib/match": [
		25054,
		7,
		25054
	],
	"./mn/_lib/match/": [
		25054,
		7,
		25054
	],
	"./mn/_lib/match/index": [
		25054,
		7,
		25054
	],
	"./mn/_lib/match/index.js": [
		25054,
		7,
		25054
	],
	"./mn/index": [
		37157,
		7,
		37157
	],
	"./mn/index.d": [
		61484,
		9,
		61484
	],
	"./mn/index.d.ts": [
		61484,
		9,
		61484
	],
	"./mn/index.js": [
		37157,
		7,
		37157
	],
	"./mn/index.js.flow": [
		18094,
		1,
		18094
	],
	"./mn/package": [
		10023,
		3,
		10023
	],
	"./mn/package.json": [
		10023,
		3,
		10023
	],
	"./ms": [
		71225,
		9,
		71225
	],
	"./ms/": [
		71225,
		9,
		71225
	],
	"./ms/_lib/formatDistance": [
		98580,
		7,
		98580
	],
	"./ms/_lib/formatDistance/": [
		98580,
		7,
		98580
	],
	"./ms/_lib/formatDistance/index": [
		98580,
		7,
		98580
	],
	"./ms/_lib/formatDistance/index.js": [
		98580,
		7,
		98580
	],
	"./ms/_lib/formatLong": [
		89720,
		7,
		89720
	],
	"./ms/_lib/formatLong/": [
		89720,
		7,
		89720
	],
	"./ms/_lib/formatLong/index": [
		89720,
		7,
		89720
	],
	"./ms/_lib/formatLong/index.js": [
		89720,
		7,
		89720
	],
	"./ms/_lib/formatRelative": [
		48497,
		7,
		48497
	],
	"./ms/_lib/formatRelative/": [
		48497,
		7,
		48497
	],
	"./ms/_lib/formatRelative/index": [
		48497,
		7,
		48497
	],
	"./ms/_lib/formatRelative/index.js": [
		48497,
		7,
		48497
	],
	"./ms/_lib/localize": [
		31269,
		7,
		31269
	],
	"./ms/_lib/localize/": [
		31269,
		7,
		31269
	],
	"./ms/_lib/localize/index": [
		31269,
		7,
		31269
	],
	"./ms/_lib/localize/index.js": [
		31269,
		7,
		31269
	],
	"./ms/_lib/match": [
		9733,
		7,
		9733
	],
	"./ms/_lib/match/": [
		9733,
		7,
		9733
	],
	"./ms/_lib/match/index": [
		9733,
		7,
		9733
	],
	"./ms/_lib/match/index.js": [
		9733,
		7,
		9733
	],
	"./ms/index": [
		44344,
		7,
		44344
	],
	"./ms/index.d": [
		32590,
		9,
		32590
	],
	"./ms/index.d.ts": [
		32590,
		9,
		32590
	],
	"./ms/index.js": [
		44344,
		7,
		44344
	],
	"./ms/index.js.flow": [
		17941,
		1,
		17941
	],
	"./ms/package": [
		79249,
		3,
		79249
	],
	"./ms/package.json": [
		79249,
		3,
		79249
	],
	"./mt": [
		95664,
		9,
		95664
	],
	"./mt/": [
		95664,
		9,
		95664
	],
	"./mt/_lib/formatDistance": [
		9705,
		7,
		9705
	],
	"./mt/_lib/formatDistance/": [
		9705,
		7,
		9705
	],
	"./mt/_lib/formatDistance/index": [
		9705,
		7,
		9705
	],
	"./mt/_lib/formatDistance/index.js": [
		9705,
		7,
		9705
	],
	"./mt/_lib/formatLong": [
		19486,
		7,
		19486
	],
	"./mt/_lib/formatLong/": [
		19486,
		7,
		19486
	],
	"./mt/_lib/formatLong/index": [
		19486,
		7,
		19486
	],
	"./mt/_lib/formatLong/index.js": [
		19486,
		7,
		19486
	],
	"./mt/_lib/formatRelative": [
		12174,
		7,
		12174
	],
	"./mt/_lib/formatRelative/": [
		12174,
		7,
		12174
	],
	"./mt/_lib/formatRelative/index": [
		12174,
		7,
		12174
	],
	"./mt/_lib/formatRelative/index.js": [
		12174,
		7,
		12174
	],
	"./mt/_lib/localize": [
		87084,
		7,
		87084
	],
	"./mt/_lib/localize/": [
		87084,
		7,
		87084
	],
	"./mt/_lib/localize/index": [
		87084,
		7,
		87084
	],
	"./mt/_lib/localize/index.js": [
		87084,
		7,
		87084
	],
	"./mt/_lib/match": [
		51962,
		7,
		51962
	],
	"./mt/_lib/match/": [
		51962,
		7,
		51962
	],
	"./mt/_lib/match/index": [
		51962,
		7,
		51962
	],
	"./mt/_lib/match/index.js": [
		51962,
		7,
		51962
	],
	"./mt/index": [
		23257,
		7,
		15671
	],
	"./mt/index.d": [
		58112,
		9,
		58112
	],
	"./mt/index.d.ts": [
		58112,
		9,
		58112
	],
	"./mt/index.js": [
		23257,
		7,
		15671
	],
	"./mt/index.js.flow": [
		37829,
		1,
		37829
	],
	"./mt/package": [
		6934,
		3,
		6934
	],
	"./mt/package.json": [
		6934,
		3,
		6934
	],
	"./nb": [
		68460,
		9,
		68460
	],
	"./nb/": [
		68460,
		9,
		68460
	],
	"./nb/_lib/formatDistance": [
		18326,
		7,
		18326
	],
	"./nb/_lib/formatDistance/": [
		18326,
		7,
		18326
	],
	"./nb/_lib/formatDistance/index": [
		18326,
		7,
		18326
	],
	"./nb/_lib/formatDistance/index.js": [
		18326,
		7,
		18326
	],
	"./nb/_lib/formatLong": [
		58974,
		7,
		58974
	],
	"./nb/_lib/formatLong/": [
		58974,
		7,
		58974
	],
	"./nb/_lib/formatLong/index": [
		58974,
		7,
		58974
	],
	"./nb/_lib/formatLong/index.js": [
		58974,
		7,
		58974
	],
	"./nb/_lib/formatRelative": [
		81015,
		7,
		81015
	],
	"./nb/_lib/formatRelative/": [
		81015,
		7,
		81015
	],
	"./nb/_lib/formatRelative/index": [
		81015,
		7,
		81015
	],
	"./nb/_lib/formatRelative/index.js": [
		81015,
		7,
		81015
	],
	"./nb/_lib/localize": [
		35609,
		7,
		35609
	],
	"./nb/_lib/localize/": [
		35609,
		7,
		35609
	],
	"./nb/_lib/localize/index": [
		35609,
		7,
		35609
	],
	"./nb/_lib/localize/index.js": [
		35609,
		7,
		35609
	],
	"./nb/_lib/match": [
		35402,
		7,
		35402
	],
	"./nb/_lib/match/": [
		35402,
		7,
		35402
	],
	"./nb/_lib/match/index": [
		35402,
		7,
		35402
	],
	"./nb/_lib/match/index.js": [
		35402,
		7,
		35402
	],
	"./nb/index": [
		52545,
		7,
		52545
	],
	"./nb/index.d": [
		84448,
		9,
		84448
	],
	"./nb/index.d.ts": [
		84448,
		9,
		84448
	],
	"./nb/index.js": [
		52545,
		7,
		52545
	],
	"./nb/index.js.flow": [
		20209,
		1,
		20209
	],
	"./nb/package": [
		63691,
		3,
		63691
	],
	"./nb/package.json": [
		63691,
		3,
		63691
	],
	"./nl": [
		8770,
		9,
		8770
	],
	"./nl-BE": [
		34471,
		9,
		34471
	],
	"./nl-BE/": [
		34471,
		9,
		34471
	],
	"./nl-BE/_lib/formatDistance": [
		74702,
		7,
		74702
	],
	"./nl-BE/_lib/formatDistance/": [
		74702,
		7,
		74702
	],
	"./nl-BE/_lib/formatDistance/index": [
		74702,
		7,
		74702
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		74702,
		7,
		74702
	],
	"./nl-BE/_lib/formatLong": [
		31302,
		7,
		31302
	],
	"./nl-BE/_lib/formatLong/": [
		31302,
		7,
		31302
	],
	"./nl-BE/_lib/formatLong/index": [
		31302,
		7,
		31302
	],
	"./nl-BE/_lib/formatLong/index.js": [
		31302,
		7,
		31302
	],
	"./nl-BE/_lib/formatRelative": [
		81309,
		7,
		81309
	],
	"./nl-BE/_lib/formatRelative/": [
		81309,
		7,
		81309
	],
	"./nl-BE/_lib/formatRelative/index": [
		81309,
		7,
		81309
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		81309,
		7,
		81309
	],
	"./nl-BE/_lib/localize": [
		81324,
		7,
		81324
	],
	"./nl-BE/_lib/localize/": [
		81324,
		7,
		81324
	],
	"./nl-BE/_lib/localize/index": [
		81324,
		7,
		81324
	],
	"./nl-BE/_lib/localize/index.js": [
		81324,
		7,
		81324
	],
	"./nl-BE/_lib/match": [
		58819,
		7,
		58819
	],
	"./nl-BE/_lib/match/": [
		58819,
		7,
		58819
	],
	"./nl-BE/_lib/match/index": [
		58819,
		7,
		58819
	],
	"./nl-BE/_lib/match/index.js": [
		58819,
		7,
		58819
	],
	"./nl-BE/index": [
		94289,
		7,
		94289
	],
	"./nl-BE/index.d": [
		82086,
		9,
		82086
	],
	"./nl-BE/index.d.ts": [
		82086,
		9,
		82086
	],
	"./nl-BE/index.js": [
		94289,
		7,
		94289
	],
	"./nl-BE/index.js.flow": [
		68550,
		1,
		68550
	],
	"./nl-BE/package": [
		92797,
		3,
		92797
	],
	"./nl-BE/package.json": [
		92797,
		3,
		92797
	],
	"./nl/": [
		8770,
		9,
		8770
	],
	"./nl/_lib/formatDistance": [
		40289,
		7,
		40289
	],
	"./nl/_lib/formatDistance/": [
		40289,
		7,
		40289
	],
	"./nl/_lib/formatDistance/index": [
		40289,
		7,
		40289
	],
	"./nl/_lib/formatDistance/index.js": [
		40289,
		7,
		40289
	],
	"./nl/_lib/formatLong": [
		71584,
		7,
		71584
	],
	"./nl/_lib/formatLong/": [
		71584,
		7,
		71584
	],
	"./nl/_lib/formatLong/index": [
		71584,
		7,
		71584
	],
	"./nl/_lib/formatLong/index.js": [
		71584,
		7,
		71584
	],
	"./nl/_lib/formatRelative": [
		22832,
		7,
		22832
	],
	"./nl/_lib/formatRelative/": [
		22832,
		7,
		22832
	],
	"./nl/_lib/formatRelative/index": [
		22832,
		7,
		22832
	],
	"./nl/_lib/formatRelative/index.js": [
		22832,
		7,
		22832
	],
	"./nl/_lib/localize": [
		80518,
		7,
		80518
	],
	"./nl/_lib/localize/": [
		80518,
		7,
		80518
	],
	"./nl/_lib/localize/index": [
		80518,
		7,
		80518
	],
	"./nl/_lib/localize/index.js": [
		80518,
		7,
		80518
	],
	"./nl/_lib/match": [
		86341,
		7,
		86341
	],
	"./nl/_lib/match/": [
		86341,
		7,
		86341
	],
	"./nl/_lib/match/index": [
		86341,
		7,
		86341
	],
	"./nl/_lib/match/index.js": [
		86341,
		7,
		86341
	],
	"./nl/index": [
		24810,
		7,
		47650
	],
	"./nl/index.d": [
		71656,
		9,
		71656
	],
	"./nl/index.d.ts": [
		71656,
		9,
		71656
	],
	"./nl/index.js": [
		24810,
		7,
		47650
	],
	"./nl/index.js.flow": [
		6667,
		1,
		6667
	],
	"./nl/package": [
		68791,
		3,
		68791
	],
	"./nl/package.json": [
		68791,
		3,
		68791
	],
	"./nn": [
		33153,
		9,
		33153
	],
	"./nn/": [
		33153,
		9,
		33153
	],
	"./nn/_lib/formatDistance": [
		49215,
		7,
		49215
	],
	"./nn/_lib/formatDistance/": [
		49215,
		7,
		49215
	],
	"./nn/_lib/formatDistance/index": [
		49215,
		7,
		49215
	],
	"./nn/_lib/formatDistance/index.js": [
		49215,
		7,
		49215
	],
	"./nn/_lib/formatLong": [
		56789,
		7,
		56789
	],
	"./nn/_lib/formatLong/": [
		56789,
		7,
		56789
	],
	"./nn/_lib/formatLong/index": [
		56789,
		7,
		56789
	],
	"./nn/_lib/formatLong/index.js": [
		56789,
		7,
		56789
	],
	"./nn/_lib/formatRelative": [
		53552,
		7,
		53552
	],
	"./nn/_lib/formatRelative/": [
		53552,
		7,
		53552
	],
	"./nn/_lib/formatRelative/index": [
		53552,
		7,
		53552
	],
	"./nn/_lib/formatRelative/index.js": [
		53552,
		7,
		53552
	],
	"./nn/_lib/localize": [
		64,
		7,
		64
	],
	"./nn/_lib/localize/": [
		64,
		7,
		64
	],
	"./nn/_lib/localize/index": [
		64,
		7,
		64
	],
	"./nn/_lib/localize/index.js": [
		64,
		7,
		64
	],
	"./nn/_lib/match": [
		68468,
		7,
		68468
	],
	"./nn/_lib/match/": [
		68468,
		7,
		68468
	],
	"./nn/_lib/match/index": [
		68468,
		7,
		68468
	],
	"./nn/_lib/match/index.js": [
		68468,
		7,
		68468
	],
	"./nn/index": [
		85411,
		7,
		85411
	],
	"./nn/index.d": [
		69257,
		9,
		69257
	],
	"./nn/index.d.ts": [
		69257,
		9,
		69257
	],
	"./nn/index.js": [
		85411,
		7,
		85411
	],
	"./nn/index.js.flow": [
		2219,
		1,
		2219
	],
	"./nn/package": [
		12390,
		3,
		46111
	],
	"./nn/package.json": [
		12390,
		3,
		46111
	],
	"./oc": [
		93832,
		9,
		93832
	],
	"./oc/": [
		93832,
		9,
		93832
	],
	"./oc/_lib/formatDistance": [
		63894,
		7,
		63894
	],
	"./oc/_lib/formatDistance/": [
		63894,
		7,
		63894
	],
	"./oc/_lib/formatDistance/index": [
		63894,
		7,
		63894
	],
	"./oc/_lib/formatDistance/index.js": [
		63894,
		7,
		63894
	],
	"./oc/_lib/formatLong": [
		40456,
		7,
		40456
	],
	"./oc/_lib/formatLong/": [
		40456,
		7,
		40456
	],
	"./oc/_lib/formatLong/index": [
		40456,
		7,
		40456
	],
	"./oc/_lib/formatLong/index.js": [
		40456,
		7,
		40456
	],
	"./oc/_lib/formatRelative": [
		68211,
		7,
		68211
	],
	"./oc/_lib/formatRelative/": [
		68211,
		7,
		68211
	],
	"./oc/_lib/formatRelative/index": [
		68211,
		7,
		68211
	],
	"./oc/_lib/formatRelative/index.js": [
		68211,
		7,
		68211
	],
	"./oc/_lib/localize": [
		47172,
		7,
		47172
	],
	"./oc/_lib/localize/": [
		47172,
		7,
		47172
	],
	"./oc/_lib/localize/index": [
		47172,
		7,
		47172
	],
	"./oc/_lib/localize/index.js": [
		47172,
		7,
		47172
	],
	"./oc/_lib/match": [
		34622,
		7,
		34622
	],
	"./oc/_lib/match/": [
		34622,
		7,
		34622
	],
	"./oc/_lib/match/index": [
		34622,
		7,
		34622
	],
	"./oc/_lib/match/index.js": [
		34622,
		7,
		34622
	],
	"./oc/index": [
		28898,
		7,
		28898
	],
	"./oc/index.d": [
		66657,
		9,
		66657
	],
	"./oc/index.d.ts": [
		66657,
		9,
		66657
	],
	"./oc/index.js": [
		28898,
		7,
		28898
	],
	"./oc/index.js.flow": [
		89695,
		1,
		89695
	],
	"./oc/package": [
		68259,
		3,
		68259
	],
	"./oc/package.json": [
		68259,
		3,
		68259
	],
	"./package": [
		87852,
		3,
		87852
	],
	"./package.json": [
		87852,
		3,
		87852
	],
	"./pl": [
		61638,
		9,
		61638
	],
	"./pl/": [
		61638,
		9,
		61638
	],
	"./pl/_lib/formatDistance": [
		84067,
		7,
		84067
	],
	"./pl/_lib/formatDistance/": [
		84067,
		7,
		84067
	],
	"./pl/_lib/formatDistance/index": [
		84067,
		7,
		84067
	],
	"./pl/_lib/formatDistance/index.js": [
		84067,
		7,
		84067
	],
	"./pl/_lib/formatLong": [
		39762,
		7,
		65918
	],
	"./pl/_lib/formatLong/": [
		39762,
		7,
		65918
	],
	"./pl/_lib/formatLong/index": [
		39762,
		7,
		65918
	],
	"./pl/_lib/formatLong/index.js": [
		39762,
		7,
		65918
	],
	"./pl/_lib/formatRelative": [
		97608,
		7,
		97608
	],
	"./pl/_lib/formatRelative/": [
		97608,
		7,
		97608
	],
	"./pl/_lib/formatRelative/index": [
		97608,
		7,
		97608
	],
	"./pl/_lib/formatRelative/index.js": [
		97608,
		7,
		97608
	],
	"./pl/_lib/localize": [
		92513,
		7,
		92513
	],
	"./pl/_lib/localize/": [
		92513,
		7,
		92513
	],
	"./pl/_lib/localize/index": [
		92513,
		7,
		92513
	],
	"./pl/_lib/localize/index.js": [
		92513,
		7,
		92513
	],
	"./pl/_lib/match": [
		38692,
		7,
		81037
	],
	"./pl/_lib/match/": [
		38692,
		7,
		81037
	],
	"./pl/_lib/match/index": [
		38692,
		7,
		81037
	],
	"./pl/_lib/match/index.js": [
		38692,
		7,
		81037
	],
	"./pl/index": [
		57237,
		7,
		57237
	],
	"./pl/index.d": [
		2138,
		9,
		2138
	],
	"./pl/index.d.ts": [
		2138,
		9,
		2138
	],
	"./pl/index.js": [
		57237,
		7,
		57237
	],
	"./pl/index.js.flow": [
		65953,
		1,
		65953
	],
	"./pl/package": [
		69261,
		3,
		69261
	],
	"./pl/package.json": [
		69261,
		3,
		69261
	],
	"./pt": [
		79939,
		9,
		79939
	],
	"./pt-BR": [
		46111,
		9
	],
	"./pt-BR/": [
		46111,
		9
	],
	"./pt-BR/_lib/formatDistance": [
		94402,
		7,
		94402
	],
	"./pt-BR/_lib/formatDistance/": [
		94402,
		7,
		94402
	],
	"./pt-BR/_lib/formatDistance/index": [
		94402,
		7,
		94402
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		94402,
		7,
		94402
	],
	"./pt-BR/_lib/formatLong": [
		70219,
		7,
		70219
	],
	"./pt-BR/_lib/formatLong/": [
		70219,
		7,
		70219
	],
	"./pt-BR/_lib/formatLong/index": [
		70219,
		7,
		70219
	],
	"./pt-BR/_lib/formatLong/index.js": [
		70219,
		7,
		70219
	],
	"./pt-BR/_lib/formatRelative": [
		84407,
		7,
		84407
	],
	"./pt-BR/_lib/formatRelative/": [
		84407,
		7,
		84407
	],
	"./pt-BR/_lib/formatRelative/index": [
		84407,
		7,
		84407
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		84407,
		7,
		84407
	],
	"./pt-BR/_lib/localize": [
		27055,
		7,
		27055
	],
	"./pt-BR/_lib/localize/": [
		27055,
		7,
		27055
	],
	"./pt-BR/_lib/localize/index": [
		27055,
		7,
		27055
	],
	"./pt-BR/_lib/localize/index.js": [
		27055,
		7,
		27055
	],
	"./pt-BR/_lib/match": [
		31404,
		7,
		31404
	],
	"./pt-BR/_lib/match/": [
		31404,
		7,
		31404
	],
	"./pt-BR/_lib/match/index": [
		31404,
		7,
		31404
	],
	"./pt-BR/_lib/match/index.js": [
		31404,
		7,
		31404
	],
	"./pt-BR/index": [
		25835,
		7,
		25835
	],
	"./pt-BR/index.d": [
		17686,
		9,
		17686
	],
	"./pt-BR/index.d.ts": [
		17686,
		9,
		17686
	],
	"./pt-BR/index.js": [
		25835,
		7,
		25835
	],
	"./pt-BR/index.js.flow": [
		30831,
		1,
		30831
	],
	"./pt-BR/package": [
		50589,
		3,
		50589
	],
	"./pt-BR/package.json": [
		50589,
		3,
		50589
	],
	"./pt/": [
		79939,
		9,
		79939
	],
	"./pt/_lib/formatDistance": [
		56361,
		7,
		56361
	],
	"./pt/_lib/formatDistance/": [
		56361,
		7,
		56361
	],
	"./pt/_lib/formatDistance/index": [
		56361,
		7,
		56361
	],
	"./pt/_lib/formatDistance/index.js": [
		56361,
		7,
		56361
	],
	"./pt/_lib/formatLong": [
		20255,
		7,
		20255
	],
	"./pt/_lib/formatLong/": [
		20255,
		7,
		20255
	],
	"./pt/_lib/formatLong/index": [
		20255,
		7,
		20255
	],
	"./pt/_lib/formatLong/index.js": [
		20255,
		7,
		20255
	],
	"./pt/_lib/formatRelative": [
		61458,
		7,
		61458
	],
	"./pt/_lib/formatRelative/": [
		61458,
		7,
		61458
	],
	"./pt/_lib/formatRelative/index": [
		61458,
		7,
		61458
	],
	"./pt/_lib/formatRelative/index.js": [
		61458,
		7,
		61458
	],
	"./pt/_lib/localize": [
		3166,
		7,
		3166
	],
	"./pt/_lib/localize/": [
		3166,
		7,
		3166
	],
	"./pt/_lib/localize/index": [
		3166,
		7,
		3166
	],
	"./pt/_lib/localize/index.js": [
		3166,
		7,
		3166
	],
	"./pt/_lib/match": [
		31067,
		7,
		31067
	],
	"./pt/_lib/match/": [
		31067,
		7,
		31067
	],
	"./pt/_lib/match/index": [
		31067,
		7,
		31067
	],
	"./pt/_lib/match/index.js": [
		31067,
		7,
		31067
	],
	"./pt/index": [
		46439,
		7,
		46439
	],
	"./pt/index.d": [
		22907,
		9,
		22907
	],
	"./pt/index.d.ts": [
		22907,
		9,
		22907
	],
	"./pt/index.js": [
		46439,
		7,
		46439
	],
	"./pt/index.js.flow": [
		8134,
		1,
		8134
	],
	"./pt/package": [
		3048,
		3,
		3048
	],
	"./pt/package.json": [
		3048,
		3,
		3048
	],
	"./ro": [
		30860,
		9,
		30860
	],
	"./ro/": [
		30860,
		9,
		30860
	],
	"./ro/_lib/formatDistance": [
		78549,
		7,
		78549
	],
	"./ro/_lib/formatDistance/": [
		78549,
		7,
		78549
	],
	"./ro/_lib/formatDistance/index": [
		78549,
		7,
		78549
	],
	"./ro/_lib/formatDistance/index.js": [
		78549,
		7,
		78549
	],
	"./ro/_lib/formatLong": [
		3947,
		7,
		3947
	],
	"./ro/_lib/formatLong/": [
		3947,
		7,
		3947
	],
	"./ro/_lib/formatLong/index": [
		3947,
		7,
		3947
	],
	"./ro/_lib/formatLong/index.js": [
		3947,
		7,
		3947
	],
	"./ro/_lib/formatRelative": [
		67217,
		7,
		67217
	],
	"./ro/_lib/formatRelative/": [
		67217,
		7,
		67217
	],
	"./ro/_lib/formatRelative/index": [
		67217,
		7,
		67217
	],
	"./ro/_lib/formatRelative/index.js": [
		67217,
		7,
		67217
	],
	"./ro/_lib/localize": [
		23079,
		7,
		23079
	],
	"./ro/_lib/localize/": [
		23079,
		7,
		23079
	],
	"./ro/_lib/localize/index": [
		23079,
		7,
		23079
	],
	"./ro/_lib/localize/index.js": [
		23079,
		7,
		23079
	],
	"./ro/_lib/match": [
		31923,
		7,
		31923
	],
	"./ro/_lib/match/": [
		31923,
		7,
		31923
	],
	"./ro/_lib/match/index": [
		31923,
		7,
		31923
	],
	"./ro/_lib/match/index.js": [
		31923,
		7,
		31923
	],
	"./ro/index": [
		42473,
		7,
		42473
	],
	"./ro/index.d": [
		82799,
		9,
		82799
	],
	"./ro/index.d.ts": [
		82799,
		9,
		82799
	],
	"./ro/index.js": [
		42473,
		7,
		42473
	],
	"./ro/index.js.flow": [
		65539,
		1,
		65539
	],
	"./ro/package": [
		78573,
		3,
		78573
	],
	"./ro/package.json": [
		78573,
		3,
		78573
	],
	"./ru": [
		21784,
		9,
		21784
	],
	"./ru/": [
		21784,
		9,
		21784
	],
	"./ru/_lib/formatDistance": [
		20991,
		7,
		20991
	],
	"./ru/_lib/formatDistance/": [
		20991,
		7,
		20991
	],
	"./ru/_lib/formatDistance/index": [
		20991,
		7,
		20991
	],
	"./ru/_lib/formatDistance/index.js": [
		20991,
		7,
		20991
	],
	"./ru/_lib/formatLong": [
		42644,
		7,
		42644
	],
	"./ru/_lib/formatLong/": [
		42644,
		7,
		42644
	],
	"./ru/_lib/formatLong/index": [
		42644,
		7,
		42644
	],
	"./ru/_lib/formatLong/index.js": [
		42644,
		7,
		42644
	],
	"./ru/_lib/formatRelative": [
		45744,
		7,
		45744
	],
	"./ru/_lib/formatRelative/": [
		45744,
		7,
		45744
	],
	"./ru/_lib/formatRelative/index": [
		45744,
		7,
		45744
	],
	"./ru/_lib/formatRelative/index.js": [
		45744,
		7,
		45744
	],
	"./ru/_lib/localize": [
		15958,
		7,
		15958
	],
	"./ru/_lib/localize/": [
		15958,
		7,
		15958
	],
	"./ru/_lib/localize/index": [
		15958,
		7,
		15958
	],
	"./ru/_lib/localize/index.js": [
		15958,
		7,
		15958
	],
	"./ru/_lib/match": [
		84257,
		7,
		84257
	],
	"./ru/_lib/match/": [
		84257,
		7,
		84257
	],
	"./ru/_lib/match/index": [
		84257,
		7,
		84257
	],
	"./ru/_lib/match/index.js": [
		84257,
		7,
		84257
	],
	"./ru/index": [
		27773,
		7,
		27773,
		96927
	],
	"./ru/index.d": [
		17000,
		9,
		17000
	],
	"./ru/index.d.ts": [
		17000,
		9,
		17000
	],
	"./ru/index.js": [
		27773,
		7,
		27773,
		96927
	],
	"./ru/index.js.flow": [
		47864,
		1,
		47864
	],
	"./ru/package": [
		30004,
		3,
		30004
	],
	"./ru/package.json": [
		30004,
		3,
		30004
	],
	"./sk": [
		83511,
		9,
		83511
	],
	"./sk/": [
		83511,
		9,
		83511
	],
	"./sk/_lib/formatDistance": [
		1843,
		7,
		1843
	],
	"./sk/_lib/formatDistance/": [
		1843,
		7,
		1843
	],
	"./sk/_lib/formatDistance/index": [
		1843,
		7,
		1843
	],
	"./sk/_lib/formatDistance/index.js": [
		1843,
		7,
		1843
	],
	"./sk/_lib/formatLong": [
		34148,
		7,
		34148
	],
	"./sk/_lib/formatLong/": [
		34148,
		7,
		34148
	],
	"./sk/_lib/formatLong/index": [
		34148,
		7,
		34148
	],
	"./sk/_lib/formatLong/index.js": [
		34148,
		7,
		34148
	],
	"./sk/_lib/formatRelative": [
		74490,
		7,
		74490
	],
	"./sk/_lib/formatRelative/": [
		74490,
		7,
		74490
	],
	"./sk/_lib/formatRelative/index": [
		74490,
		7,
		74490
	],
	"./sk/_lib/formatRelative/index.js": [
		74490,
		7,
		74490
	],
	"./sk/_lib/localize": [
		96540,
		7,
		96540
	],
	"./sk/_lib/localize/": [
		96540,
		7,
		96540
	],
	"./sk/_lib/localize/index": [
		96540,
		7,
		96540
	],
	"./sk/_lib/localize/index.js": [
		96540,
		7,
		96540
	],
	"./sk/_lib/match": [
		5973,
		7,
		5973
	],
	"./sk/_lib/match/": [
		5973,
		7,
		5973
	],
	"./sk/_lib/match/index": [
		5973,
		7,
		5973
	],
	"./sk/_lib/match/index.js": [
		5973,
		7,
		5973
	],
	"./sk/index": [
		29604,
		7,
		29604
	],
	"./sk/index.d": [
		40038,
		9,
		40038
	],
	"./sk/index.d.ts": [
		40038,
		9,
		40038
	],
	"./sk/index.js": [
		29604,
		7,
		29604
	],
	"./sk/index.js.flow": [
		34084,
		1,
		34084
	],
	"./sk/package": [
		64262,
		3,
		64262
	],
	"./sk/package.json": [
		64262,
		3,
		64262
	],
	"./sl": [
		16039,
		9,
		16039
	],
	"./sl/": [
		16039,
		9,
		16039
	],
	"./sl/_lib/formatDistance": [
		25190,
		7,
		25190
	],
	"./sl/_lib/formatDistance/": [
		25190,
		7,
		25190
	],
	"./sl/_lib/formatDistance/index": [
		25190,
		7,
		25190
	],
	"./sl/_lib/formatDistance/index.js": [
		25190,
		7,
		25190
	],
	"./sl/_lib/formatLong": [
		67123,
		7,
		67123
	],
	"./sl/_lib/formatLong/": [
		67123,
		7,
		67123
	],
	"./sl/_lib/formatLong/index": [
		67123,
		7,
		67123
	],
	"./sl/_lib/formatLong/index.js": [
		67123,
		7,
		67123
	],
	"./sl/_lib/formatRelative": [
		41230,
		7,
		41230
	],
	"./sl/_lib/formatRelative/": [
		41230,
		7,
		41230
	],
	"./sl/_lib/formatRelative/index": [
		41230,
		7,
		41230
	],
	"./sl/_lib/formatRelative/index.js": [
		41230,
		7,
		41230
	],
	"./sl/_lib/localize": [
		18668,
		7,
		18668
	],
	"./sl/_lib/localize/": [
		18668,
		7,
		18668
	],
	"./sl/_lib/localize/index": [
		18668,
		7,
		18668
	],
	"./sl/_lib/localize/index.js": [
		18668,
		7,
		18668
	],
	"./sl/_lib/match": [
		45932,
		7,
		45932
	],
	"./sl/_lib/match/": [
		45932,
		7,
		45932
	],
	"./sl/_lib/match/index": [
		45932,
		7,
		45932
	],
	"./sl/_lib/match/index.js": [
		45932,
		7,
		45932
	],
	"./sl/index": [
		52792,
		7,
		52792
	],
	"./sl/index.d": [
		69832,
		9,
		69832
	],
	"./sl/index.d.ts": [
		69832,
		9,
		69832
	],
	"./sl/index.js": [
		52792,
		7,
		52792
	],
	"./sl/index.js.flow": [
		37378,
		1,
		37378
	],
	"./sl/package": [
		96286,
		3,
		96286
	],
	"./sl/package.json": [
		96286,
		3,
		96286
	],
	"./sq": [
		75417,
		9,
		75417
	],
	"./sq/": [
		75417,
		9,
		75417
	],
	"./sq/_lib/formatDistance": [
		26652,
		7,
		26652
	],
	"./sq/_lib/formatDistance/": [
		26652,
		7,
		26652
	],
	"./sq/_lib/formatDistance/index": [
		26652,
		7,
		26652
	],
	"./sq/_lib/formatDistance/index.js": [
		26652,
		7,
		26652
	],
	"./sq/_lib/formatLong": [
		44933,
		7,
		44933
	],
	"./sq/_lib/formatLong/": [
		44933,
		7,
		44933
	],
	"./sq/_lib/formatLong/index": [
		44933,
		7,
		44933
	],
	"./sq/_lib/formatLong/index.js": [
		44933,
		7,
		44933
	],
	"./sq/_lib/formatRelative": [
		68933,
		7,
		68933
	],
	"./sq/_lib/formatRelative/": [
		68933,
		7,
		68933
	],
	"./sq/_lib/formatRelative/index": [
		68933,
		7,
		68933
	],
	"./sq/_lib/formatRelative/index.js": [
		68933,
		7,
		68933
	],
	"./sq/_lib/localize": [
		92941,
		7,
		92941
	],
	"./sq/_lib/localize/": [
		92941,
		7,
		92941
	],
	"./sq/_lib/localize/index": [
		92941,
		7,
		92941
	],
	"./sq/_lib/localize/index.js": [
		92941,
		7,
		92941
	],
	"./sq/_lib/match": [
		14170,
		7,
		14170
	],
	"./sq/_lib/match/": [
		14170,
		7,
		14170
	],
	"./sq/_lib/match/index": [
		14170,
		7,
		14170
	],
	"./sq/_lib/match/index.js": [
		14170,
		7,
		14170
	],
	"./sq/index": [
		42870,
		7,
		42870
	],
	"./sq/index.d": [
		96974,
		9,
		96974
	],
	"./sq/index.d.ts": [
		96974,
		9,
		96974
	],
	"./sq/index.js": [
		42870,
		7,
		42870
	],
	"./sq/index.js.flow": [
		52074,
		1,
		52074
	],
	"./sq/package": [
		46696,
		3,
		46696
	],
	"./sq/package.json": [
		46696,
		3,
		46696
	],
	"./sr": [
		87367,
		9,
		87367
	],
	"./sr-Latn": [
		31128,
		9,
		31128
	],
	"./sr-Latn/": [
		31128,
		9,
		31128
	],
	"./sr-Latn/_lib/formatDistance": [
		609,
		7,
		609
	],
	"./sr-Latn/_lib/formatDistance/": [
		609,
		7,
		609
	],
	"./sr-Latn/_lib/formatDistance/index": [
		609,
		7,
		609
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		609,
		7,
		609
	],
	"./sr-Latn/_lib/formatLong": [
		94394,
		7,
		94394
	],
	"./sr-Latn/_lib/formatLong/": [
		94394,
		7,
		94394
	],
	"./sr-Latn/_lib/formatLong/index": [
		94394,
		7,
		94394
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		94394,
		7,
		94394
	],
	"./sr-Latn/_lib/formatRelative": [
		51251,
		7,
		51251
	],
	"./sr-Latn/_lib/formatRelative/": [
		51251,
		7,
		51251
	],
	"./sr-Latn/_lib/formatRelative/index": [
		51251,
		7,
		51251
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		51251,
		7,
		51251
	],
	"./sr-Latn/_lib/localize": [
		69554,
		7,
		69554
	],
	"./sr-Latn/_lib/localize/": [
		69554,
		7,
		69554
	],
	"./sr-Latn/_lib/localize/index": [
		69554,
		7,
		69554
	],
	"./sr-Latn/_lib/localize/index.js": [
		69554,
		7,
		69554
	],
	"./sr-Latn/_lib/match": [
		15689,
		7,
		15689
	],
	"./sr-Latn/_lib/match/": [
		15689,
		7,
		15689
	],
	"./sr-Latn/_lib/match/index": [
		15689,
		7,
		15689
	],
	"./sr-Latn/_lib/match/index.js": [
		15689,
		7,
		15689
	],
	"./sr-Latn/index": [
		46732,
		7,
		46732
	],
	"./sr-Latn/index.d": [
		8338,
		9,
		8338
	],
	"./sr-Latn/index.d.ts": [
		8338,
		9,
		8338
	],
	"./sr-Latn/index.js": [
		46732,
		7,
		46732
	],
	"./sr-Latn/index.js.flow": [
		46231,
		1,
		46231
	],
	"./sr-Latn/package": [
		90046,
		3,
		90046
	],
	"./sr-Latn/package.json": [
		90046,
		3,
		90046
	],
	"./sr/": [
		87367,
		9,
		87367
	],
	"./sr/_lib/formatDistance": [
		27352,
		7,
		27352
	],
	"./sr/_lib/formatDistance/": [
		27352,
		7,
		27352
	],
	"./sr/_lib/formatDistance/index": [
		27352,
		7,
		27352
	],
	"./sr/_lib/formatDistance/index.js": [
		27352,
		7,
		27352
	],
	"./sr/_lib/formatLong": [
		50455,
		7,
		50455
	],
	"./sr/_lib/formatLong/": [
		50455,
		7,
		50455
	],
	"./sr/_lib/formatLong/index": [
		50455,
		7,
		50455
	],
	"./sr/_lib/formatLong/index.js": [
		50455,
		7,
		50455
	],
	"./sr/_lib/formatRelative": [
		43039,
		7,
		43039
	],
	"./sr/_lib/formatRelative/": [
		43039,
		7,
		43039
	],
	"./sr/_lib/formatRelative/index": [
		43039,
		7,
		43039
	],
	"./sr/_lib/formatRelative/index.js": [
		43039,
		7,
		43039
	],
	"./sr/_lib/localize": [
		50574,
		7,
		50574
	],
	"./sr/_lib/localize/": [
		50574,
		7,
		50574
	],
	"./sr/_lib/localize/index": [
		50574,
		7,
		50574
	],
	"./sr/_lib/localize/index.js": [
		50574,
		7,
		50574
	],
	"./sr/_lib/match": [
		81764,
		7,
		81764
	],
	"./sr/_lib/match/": [
		81764,
		7,
		81764
	],
	"./sr/_lib/match/index": [
		81764,
		7,
		81764
	],
	"./sr/_lib/match/index.js": [
		81764,
		7,
		81764
	],
	"./sr/index": [
		76600,
		7,
		76600
	],
	"./sr/index.d": [
		4065,
		9,
		4065
	],
	"./sr/index.d.ts": [
		4065,
		9,
		4065
	],
	"./sr/index.js": [
		76600,
		7,
		76600
	],
	"./sr/index.js.flow": [
		55384,
		1,
		55384
	],
	"./sr/package": [
		66941,
		3,
		44046
	],
	"./sr/package.json": [
		66941,
		3,
		44046
	],
	"./sv": [
		89505,
		9,
		89505
	],
	"./sv/": [
		89505,
		9,
		89505
	],
	"./sv/_lib/formatDistance": [
		13977,
		7,
		13977
	],
	"./sv/_lib/formatDistance/": [
		13977,
		7,
		13977
	],
	"./sv/_lib/formatDistance/index": [
		13977,
		7,
		13977
	],
	"./sv/_lib/formatDistance/index.js": [
		13977,
		7,
		13977
	],
	"./sv/_lib/formatLong": [
		86777,
		7,
		86777
	],
	"./sv/_lib/formatLong/": [
		86777,
		7,
		86777
	],
	"./sv/_lib/formatLong/index": [
		86777,
		7,
		86777
	],
	"./sv/_lib/formatLong/index.js": [
		86777,
		7,
		86777
	],
	"./sv/_lib/formatRelative": [
		71530,
		7,
		71530
	],
	"./sv/_lib/formatRelative/": [
		71530,
		7,
		71530
	],
	"./sv/_lib/formatRelative/index": [
		71530,
		7,
		71530
	],
	"./sv/_lib/formatRelative/index.js": [
		71530,
		7,
		71530
	],
	"./sv/_lib/localize": [
		62931,
		7,
		62931
	],
	"./sv/_lib/localize/": [
		62931,
		7,
		62931
	],
	"./sv/_lib/localize/index": [
		62931,
		7,
		62931
	],
	"./sv/_lib/localize/index.js": [
		62931,
		7,
		62931
	],
	"./sv/_lib/match": [
		77262,
		7,
		77262
	],
	"./sv/_lib/match/": [
		77262,
		7,
		77262
	],
	"./sv/_lib/match/index": [
		77262,
		7,
		77262
	],
	"./sv/_lib/match/index.js": [
		77262,
		7,
		77262
	],
	"./sv/index": [
		88573,
		7,
		88573
	],
	"./sv/index.d": [
		72473,
		9,
		72473
	],
	"./sv/index.d.ts": [
		72473,
		9,
		72473
	],
	"./sv/index.js": [
		88573,
		7,
		88573
	],
	"./sv/index.js.flow": [
		24016,
		1,
		24016
	],
	"./sv/package": [
		49767,
		3,
		49767
	],
	"./sv/package.json": [
		49767,
		3,
		49767
	],
	"./ta": [
		63647,
		9,
		63647
	],
	"./ta/": [
		63647,
		9,
		63647
	],
	"./ta/_lib/formatDistance": [
		80825,
		7,
		80825
	],
	"./ta/_lib/formatDistance/": [
		80825,
		7,
		80825
	],
	"./ta/_lib/formatDistance/index": [
		80825,
		7,
		80825
	],
	"./ta/_lib/formatDistance/index.js": [
		80825,
		7,
		80825
	],
	"./ta/_lib/formatLong": [
		4433,
		7,
		4433
	],
	"./ta/_lib/formatLong/": [
		4433,
		7,
		4433
	],
	"./ta/_lib/formatLong/index": [
		4433,
		7,
		4433
	],
	"./ta/_lib/formatLong/index.js": [
		4433,
		7,
		4433
	],
	"./ta/_lib/formatRelative": [
		95694,
		7,
		95694
	],
	"./ta/_lib/formatRelative/": [
		95694,
		7,
		95694
	],
	"./ta/_lib/formatRelative/index": [
		95694,
		7,
		95694
	],
	"./ta/_lib/formatRelative/index.js": [
		95694,
		7,
		95694
	],
	"./ta/_lib/localize": [
		96828,
		7,
		96828
	],
	"./ta/_lib/localize/": [
		96828,
		7,
		96828
	],
	"./ta/_lib/localize/index": [
		96828,
		7,
		96828
	],
	"./ta/_lib/localize/index.js": [
		96828,
		7,
		96828
	],
	"./ta/_lib/match": [
		43903,
		7,
		43903
	],
	"./ta/_lib/match/": [
		43903,
		7,
		43903
	],
	"./ta/_lib/match/index": [
		43903,
		7,
		43903
	],
	"./ta/_lib/match/index.js": [
		43903,
		7,
		43903
	],
	"./ta/index": [
		84588,
		7,
		84588,
		17907
	],
	"./ta/index.d": [
		54831,
		9,
		54831
	],
	"./ta/index.d.ts": [
		54831,
		9,
		54831
	],
	"./ta/index.js": [
		84588,
		7,
		84588,
		17907
	],
	"./ta/index.js.flow": [
		9784,
		1,
		9784
	],
	"./ta/package": [
		12520,
		3,
		12520
	],
	"./ta/package.json": [
		12520,
		3,
		12520
	],
	"./te": [
		90630,
		9,
		90630
	],
	"./te/": [
		90630,
		9,
		90630
	],
	"./te/_lib/formatDistance": [
		38968,
		7,
		38968
	],
	"./te/_lib/formatDistance/": [
		38968,
		7,
		38968
	],
	"./te/_lib/formatDistance/index": [
		38968,
		7,
		38968
	],
	"./te/_lib/formatDistance/index.js": [
		38968,
		7,
		38968
	],
	"./te/_lib/formatLong": [
		81098,
		7,
		81098
	],
	"./te/_lib/formatLong/": [
		81098,
		7,
		81098
	],
	"./te/_lib/formatLong/index": [
		81098,
		7,
		81098
	],
	"./te/_lib/formatLong/index.js": [
		81098,
		7,
		81098
	],
	"./te/_lib/formatRelative": [
		28283,
		7,
		28283
	],
	"./te/_lib/formatRelative/": [
		28283,
		7,
		28283
	],
	"./te/_lib/formatRelative/index": [
		28283,
		7,
		28283
	],
	"./te/_lib/formatRelative/index.js": [
		28283,
		7,
		28283
	],
	"./te/_lib/localize": [
		41533,
		7,
		41533
	],
	"./te/_lib/localize/": [
		41533,
		7,
		41533
	],
	"./te/_lib/localize/index": [
		41533,
		7,
		41533
	],
	"./te/_lib/localize/index.js": [
		41533,
		7,
		41533
	],
	"./te/_lib/match": [
		5186,
		7,
		5186
	],
	"./te/_lib/match/": [
		5186,
		7,
		5186
	],
	"./te/_lib/match/index": [
		5186,
		7,
		5186
	],
	"./te/_lib/match/index.js": [
		5186,
		7,
		5186
	],
	"./te/index": [
		17631,
		7,
		17631
	],
	"./te/index.d": [
		47620,
		9,
		47620
	],
	"./te/index.d.ts": [
		47620,
		9,
		47620
	],
	"./te/index.js": [
		17631,
		7,
		17631
	],
	"./te/index.js.flow": [
		60893,
		1,
		60893
	],
	"./te/package": [
		49083,
		3,
		49083
	],
	"./te/package.json": [
		49083,
		3,
		49083
	],
	"./th": [
		38891,
		9,
		38891
	],
	"./th/": [
		38891,
		9,
		38891
	],
	"./th/_lib/formatDistance": [
		32819,
		7,
		32819
	],
	"./th/_lib/formatDistance/": [
		32819,
		7,
		32819
	],
	"./th/_lib/formatDistance/index": [
		32819,
		7,
		32819
	],
	"./th/_lib/formatDistance/index.js": [
		32819,
		7,
		32819
	],
	"./th/_lib/formatLong": [
		24247,
		7,
		24247
	],
	"./th/_lib/formatLong/": [
		24247,
		7,
		24247
	],
	"./th/_lib/formatLong/index": [
		24247,
		7,
		24247
	],
	"./th/_lib/formatLong/index.js": [
		24247,
		7,
		24247
	],
	"./th/_lib/formatRelative": [
		58155,
		7,
		58155
	],
	"./th/_lib/formatRelative/": [
		58155,
		7,
		58155
	],
	"./th/_lib/formatRelative/index": [
		58155,
		7,
		58155
	],
	"./th/_lib/formatRelative/index.js": [
		58155,
		7,
		58155
	],
	"./th/_lib/localize": [
		60254,
		7,
		60254
	],
	"./th/_lib/localize/": [
		60254,
		7,
		60254
	],
	"./th/_lib/localize/index": [
		60254,
		7,
		60254
	],
	"./th/_lib/localize/index.js": [
		60254,
		7,
		60254
	],
	"./th/_lib/match": [
		86319,
		7,
		86319
	],
	"./th/_lib/match/": [
		86319,
		7,
		86319
	],
	"./th/_lib/match/index": [
		86319,
		7,
		86319
	],
	"./th/_lib/match/index.js": [
		86319,
		7,
		86319
	],
	"./th/index": [
		88002,
		7,
		88002
	],
	"./th/index.d": [
		64472,
		9,
		64472
	],
	"./th/index.d.ts": [
		64472,
		9,
		64472
	],
	"./th/index.js": [
		88002,
		7,
		88002
	],
	"./th/index.js.flow": [
		69667,
		1,
		69667
	],
	"./th/package": [
		32022,
		3,
		32022
	],
	"./th/package.json": [
		32022,
		3,
		32022
	],
	"./tr": [
		69016,
		9,
		69016
	],
	"./tr/": [
		69016,
		9,
		69016
	],
	"./tr/_lib/formatDistance": [
		77302,
		7,
		77302
	],
	"./tr/_lib/formatDistance/": [
		77302,
		7,
		77302
	],
	"./tr/_lib/formatDistance/index": [
		77302,
		7,
		77302
	],
	"./tr/_lib/formatDistance/index.js": [
		77302,
		7,
		77302
	],
	"./tr/_lib/formatLong": [
		32946,
		7,
		32946
	],
	"./tr/_lib/formatLong/": [
		32946,
		7,
		32946
	],
	"./tr/_lib/formatLong/index": [
		32946,
		7,
		32946
	],
	"./tr/_lib/formatLong/index.js": [
		32946,
		7,
		32946
	],
	"./tr/_lib/formatRelative": [
		67003,
		7,
		67003
	],
	"./tr/_lib/formatRelative/": [
		67003,
		7,
		67003
	],
	"./tr/_lib/formatRelative/index": [
		67003,
		7,
		67003
	],
	"./tr/_lib/formatRelative/index.js": [
		67003,
		7,
		67003
	],
	"./tr/_lib/localize": [
		2945,
		7,
		2945
	],
	"./tr/_lib/localize/": [
		2945,
		7,
		2945
	],
	"./tr/_lib/localize/index": [
		2945,
		7,
		2945
	],
	"./tr/_lib/localize/index.js": [
		2945,
		7,
		2945
	],
	"./tr/_lib/match": [
		24552,
		7,
		24552
	],
	"./tr/_lib/match/": [
		24552,
		7,
		24552
	],
	"./tr/_lib/match/index": [
		24552,
		7,
		24552
	],
	"./tr/_lib/match/index.js": [
		24552,
		7,
		24552
	],
	"./tr/index": [
		34848,
		7,
		34848
	],
	"./tr/index.d": [
		62624,
		9,
		62624
	],
	"./tr/index.d.ts": [
		62624,
		9,
		62624
	],
	"./tr/index.js": [
		34848,
		7,
		34848
	],
	"./tr/index.js.flow": [
		12754,
		1,
		12754
	],
	"./tr/package": [
		34953,
		3,
		34953
	],
	"./tr/package.json": [
		34953,
		3,
		34953
	],
	"./types": [
		30578,
		9,
		32993
	],
	"./types.js": [
		30578,
		9,
		32993
	],
	"./ug": [
		74822,
		9,
		74822
	],
	"./ug/": [
		74822,
		9,
		74822
	],
	"./ug/_lib/formatDistance": [
		84769,
		7,
		84769
	],
	"./ug/_lib/formatDistance/": [
		84769,
		7,
		84769
	],
	"./ug/_lib/formatDistance/index": [
		84769,
		7,
		84769
	],
	"./ug/_lib/formatDistance/index.js": [
		84769,
		7,
		84769
	],
	"./ug/_lib/formatLong": [
		18384,
		7,
		18384
	],
	"./ug/_lib/formatLong/": [
		18384,
		7,
		18384
	],
	"./ug/_lib/formatLong/index": [
		18384,
		7,
		18384
	],
	"./ug/_lib/formatLong/index.js": [
		18384,
		7,
		18384
	],
	"./ug/_lib/formatRelative": [
		47243,
		7,
		47243
	],
	"./ug/_lib/formatRelative/": [
		47243,
		7,
		47243
	],
	"./ug/_lib/formatRelative/index": [
		47243,
		7,
		47243
	],
	"./ug/_lib/formatRelative/index.js": [
		47243,
		7,
		47243
	],
	"./ug/_lib/localize": [
		88480,
		7,
		88480
	],
	"./ug/_lib/localize/": [
		88480,
		7,
		88480
	],
	"./ug/_lib/localize/index": [
		88480,
		7,
		88480
	],
	"./ug/_lib/localize/index.js": [
		88480,
		7,
		88480
	],
	"./ug/_lib/match": [
		89933,
		7,
		89933
	],
	"./ug/_lib/match/": [
		89933,
		7,
		89933
	],
	"./ug/_lib/match/index": [
		89933,
		7,
		89933
	],
	"./ug/_lib/match/index.js": [
		89933,
		7,
		89933
	],
	"./ug/index": [
		41296,
		7,
		41296
	],
	"./ug/index.d": [
		74061,
		9,
		74061
	],
	"./ug/index.d.ts": [
		74061,
		9,
		74061
	],
	"./ug/index.js": [
		41296,
		7,
		41296
	],
	"./ug/index.js.flow": [
		46360,
		1,
		46360
	],
	"./ug/package": [
		65078,
		3,
		65078
	],
	"./ug/package.json": [
		65078,
		3,
		65078
	],
	"./uk": [
		46545,
		9,
		46545
	],
	"./uk/": [
		46545,
		9,
		46545
	],
	"./uk/_lib/formatDistance": [
		99785,
		7,
		99785
	],
	"./uk/_lib/formatDistance/": [
		99785,
		7,
		99785
	],
	"./uk/_lib/formatDistance/index": [
		99785,
		7,
		99785
	],
	"./uk/_lib/formatDistance/index.js": [
		99785,
		7,
		99785
	],
	"./uk/_lib/formatLong": [
		3250,
		7,
		3250
	],
	"./uk/_lib/formatLong/": [
		3250,
		7,
		3250
	],
	"./uk/_lib/formatLong/index": [
		3250,
		7,
		3250
	],
	"./uk/_lib/formatLong/index.js": [
		3250,
		7,
		3250
	],
	"./uk/_lib/formatRelative": [
		99101,
		7,
		57223,
		92982,
		99101
	],
	"./uk/_lib/formatRelative/": [
		99101,
		7,
		57223,
		92982,
		99101
	],
	"./uk/_lib/formatRelative/index": [
		99101,
		7,
		57223,
		92982,
		99101
	],
	"./uk/_lib/formatRelative/index.js": [
		99101,
		7,
		57223,
		92982,
		99101
	],
	"./uk/_lib/localize": [
		99145,
		7,
		99145
	],
	"./uk/_lib/localize/": [
		99145,
		7,
		99145
	],
	"./uk/_lib/localize/index": [
		99145,
		7,
		99145
	],
	"./uk/_lib/localize/index.js": [
		99145,
		7,
		99145
	],
	"./uk/_lib/match": [
		4014,
		7,
		4014
	],
	"./uk/_lib/match/": [
		4014,
		7,
		4014
	],
	"./uk/_lib/match/index": [
		4014,
		7,
		4014
	],
	"./uk/_lib/match/index.js": [
		4014,
		7,
		4014
	],
	"./uk/index": [
		75099,
		7,
		57223,
		92982,
		20511
	],
	"./uk/index.d": [
		79438,
		9,
		79438
	],
	"./uk/index.d.ts": [
		79438,
		9,
		79438
	],
	"./uk/index.js": [
		75099,
		7,
		57223,
		92982,
		20511
	],
	"./uk/index.js.flow": [
		14718,
		1,
		14718
	],
	"./uk/package": [
		61629,
		3,
		61629
	],
	"./uk/package.json": [
		61629,
		3,
		61629
	],
	"./uz": [
		58365,
		9,
		58365
	],
	"./uz-Cyrl": [
		12066,
		9,
		12066
	],
	"./uz-Cyrl/": [
		12066,
		9,
		12066
	],
	"./uz-Cyrl/_lib/formatDistance": [
		80036,
		7,
		80036
	],
	"./uz-Cyrl/_lib/formatDistance/": [
		80036,
		7,
		80036
	],
	"./uz-Cyrl/_lib/formatDistance/index": [
		80036,
		7,
		80036
	],
	"./uz-Cyrl/_lib/formatDistance/index.js": [
		80036,
		7,
		80036
	],
	"./uz-Cyrl/_lib/formatLong": [
		57430,
		7,
		57430
	],
	"./uz-Cyrl/_lib/formatLong/": [
		57430,
		7,
		57430
	],
	"./uz-Cyrl/_lib/formatLong/index": [
		57430,
		7,
		57430
	],
	"./uz-Cyrl/_lib/formatLong/index.js": [
		57430,
		7,
		57430
	],
	"./uz-Cyrl/_lib/formatRelative": [
		70145,
		7,
		70145
	],
	"./uz-Cyrl/_lib/formatRelative/": [
		70145,
		7,
		70145
	],
	"./uz-Cyrl/_lib/formatRelative/index": [
		70145,
		7,
		70145
	],
	"./uz-Cyrl/_lib/formatRelative/index.js": [
		70145,
		7,
		70145
	],
	"./uz-Cyrl/_lib/localize": [
		43520,
		7,
		43520
	],
	"./uz-Cyrl/_lib/localize/": [
		43520,
		7,
		43520
	],
	"./uz-Cyrl/_lib/localize/index": [
		43520,
		7,
		43520
	],
	"./uz-Cyrl/_lib/localize/index.js": [
		43520,
		7,
		43520
	],
	"./uz-Cyrl/_lib/match": [
		79014,
		7,
		79014
	],
	"./uz-Cyrl/_lib/match/": [
		79014,
		7,
		79014
	],
	"./uz-Cyrl/_lib/match/index": [
		79014,
		7,
		79014
	],
	"./uz-Cyrl/_lib/match/index.js": [
		79014,
		7,
		79014
	],
	"./uz-Cyrl/index": [
		2051,
		7,
		2051
	],
	"./uz-Cyrl/index.d": [
		75050,
		9,
		75050
	],
	"./uz-Cyrl/index.d.ts": [
		75050,
		9,
		75050
	],
	"./uz-Cyrl/index.js": [
		2051,
		7,
		2051
	],
	"./uz-Cyrl/index.js.flow": [
		15125,
		1,
		15125
	],
	"./uz-Cyrl/package": [
		8939,
		3,
		8939
	],
	"./uz-Cyrl/package.json": [
		8939,
		3,
		8939
	],
	"./uz/": [
		58365,
		9,
		58365
	],
	"./uz/_lib/formatDistance": [
		57663,
		7,
		57663
	],
	"./uz/_lib/formatDistance/": [
		57663,
		7,
		57663
	],
	"./uz/_lib/formatDistance/index": [
		57663,
		7,
		57663
	],
	"./uz/_lib/formatDistance/index.js": [
		57663,
		7,
		57663
	],
	"./uz/_lib/formatLong": [
		97836,
		7,
		97836
	],
	"./uz/_lib/formatLong/": [
		97836,
		7,
		97836
	],
	"./uz/_lib/formatLong/index": [
		97836,
		7,
		97836
	],
	"./uz/_lib/formatLong/index.js": [
		97836,
		7,
		97836
	],
	"./uz/_lib/formatRelative": [
		15295,
		7,
		15295
	],
	"./uz/_lib/formatRelative/": [
		15295,
		7,
		15295
	],
	"./uz/_lib/formatRelative/index": [
		15295,
		7,
		15295
	],
	"./uz/_lib/formatRelative/index.js": [
		15295,
		7,
		15295
	],
	"./uz/_lib/localize": [
		94622,
		7,
		94622
	],
	"./uz/_lib/localize/": [
		94622,
		7,
		94622
	],
	"./uz/_lib/localize/index": [
		94622,
		7,
		94622
	],
	"./uz/_lib/localize/index.js": [
		94622,
		7,
		94622
	],
	"./uz/_lib/match": [
		42382,
		7,
		42382
	],
	"./uz/_lib/match/": [
		42382,
		7,
		42382
	],
	"./uz/_lib/match/index": [
		42382,
		7,
		42382
	],
	"./uz/_lib/match/index.js": [
		42382,
		7,
		42382
	],
	"./uz/index": [
		1039,
		7,
		1039
	],
	"./uz/index.d": [
		56204,
		9,
		56204
	],
	"./uz/index.d.ts": [
		56204,
		9,
		56204
	],
	"./uz/index.js": [
		1039,
		7,
		1039
	],
	"./uz/index.js.flow": [
		42072,
		1,
		42072
	],
	"./uz/package": [
		16840,
		3,
		16840
	],
	"./uz/package.json": [
		16840,
		3,
		16840
	],
	"./vi": [
		24732,
		9,
		24732
	],
	"./vi/": [
		24732,
		9,
		24732
	],
	"./vi/_lib/formatDistance": [
		89528,
		7,
		89528
	],
	"./vi/_lib/formatDistance/": [
		89528,
		7,
		89528
	],
	"./vi/_lib/formatDistance/index": [
		89528,
		7,
		89528
	],
	"./vi/_lib/formatDistance/index.js": [
		89528,
		7,
		89528
	],
	"./vi/_lib/formatLong": [
		48580,
		7,
		48580
	],
	"./vi/_lib/formatLong/": [
		48580,
		7,
		48580
	],
	"./vi/_lib/formatLong/index": [
		48580,
		7,
		48580
	],
	"./vi/_lib/formatLong/index.js": [
		48580,
		7,
		48580
	],
	"./vi/_lib/formatRelative": [
		22993,
		7,
		22993
	],
	"./vi/_lib/formatRelative/": [
		22993,
		7,
		22993
	],
	"./vi/_lib/formatRelative/index": [
		22993,
		7,
		22993
	],
	"./vi/_lib/formatRelative/index.js": [
		22993,
		7,
		22993
	],
	"./vi/_lib/localize": [
		20764,
		7,
		20764
	],
	"./vi/_lib/localize/": [
		20764,
		7,
		20764
	],
	"./vi/_lib/localize/index": [
		20764,
		7,
		20764
	],
	"./vi/_lib/localize/index.js": [
		20764,
		7,
		20764
	],
	"./vi/_lib/match": [
		89470,
		7,
		89470
	],
	"./vi/_lib/match/": [
		89470,
		7,
		89470
	],
	"./vi/_lib/match/index": [
		89470,
		7,
		89470
	],
	"./vi/_lib/match/index.js": [
		89470,
		7,
		89470
	],
	"./vi/index": [
		67392,
		7,
		67392
	],
	"./vi/index.d": [
		26371,
		9,
		26371
	],
	"./vi/index.d.ts": [
		26371,
		9,
		26371
	],
	"./vi/index.js": [
		67392,
		7,
		67392
	],
	"./vi/index.js.flow": [
		82892,
		1,
		82892
	],
	"./vi/package": [
		12629,
		3,
		12629
	],
	"./vi/package.json": [
		12629,
		3,
		12629
	],
	"./zh-CN": [
		36823,
		9,
		36823
	],
	"./zh-CN/": [
		36823,
		9,
		36823
	],
	"./zh-CN/_lib/formatDistance": [
		95867,
		7,
		95867
	],
	"./zh-CN/_lib/formatDistance/": [
		95867,
		7,
		95867
	],
	"./zh-CN/_lib/formatDistance/index": [
		95867,
		7,
		95867
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		95867,
		7,
		95867
	],
	"./zh-CN/_lib/formatLong": [
		33002,
		7,
		33002
	],
	"./zh-CN/_lib/formatLong/": [
		33002,
		7,
		33002
	],
	"./zh-CN/_lib/formatLong/index": [
		33002,
		7,
		33002
	],
	"./zh-CN/_lib/formatLong/index.js": [
		33002,
		7,
		33002
	],
	"./zh-CN/_lib/formatRelative": [
		10317,
		7,
		10317
	],
	"./zh-CN/_lib/formatRelative/": [
		10317,
		7,
		10317
	],
	"./zh-CN/_lib/formatRelative/index": [
		10317,
		7,
		10317
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		10317,
		7,
		10317
	],
	"./zh-CN/_lib/localize": [
		89546,
		7,
		89546
	],
	"./zh-CN/_lib/localize/": [
		89546,
		7,
		89546
	],
	"./zh-CN/_lib/localize/index": [
		89546,
		7,
		89546
	],
	"./zh-CN/_lib/localize/index.js": [
		89546,
		7,
		89546
	],
	"./zh-CN/_lib/match": [
		885,
		7,
		885
	],
	"./zh-CN/_lib/match/": [
		885,
		7,
		885
	],
	"./zh-CN/_lib/match/index": [
		885,
		7,
		885
	],
	"./zh-CN/_lib/match/index.js": [
		885,
		7,
		885
	],
	"./zh-CN/index": [
		58479,
		7,
		58479
	],
	"./zh-CN/index.d": [
		1358,
		9,
		1358
	],
	"./zh-CN/index.d.ts": [
		1358,
		9,
		1358
	],
	"./zh-CN/index.js": [
		58479,
		7,
		58479
	],
	"./zh-CN/index.js.flow": [
		1442,
		1,
		1442
	],
	"./zh-CN/package": [
		55739,
		3,
		55739
	],
	"./zh-CN/package.json": [
		55739,
		3,
		55739
	],
	"./zh-HK": [
		89205,
		9,
		89205
	],
	"./zh-HK/": [
		89205,
		9,
		89205
	],
	"./zh-HK/_lib/formatDistance": [
		38408,
		7,
		38408
	],
	"./zh-HK/_lib/formatDistance/": [
		38408,
		7,
		38408
	],
	"./zh-HK/_lib/formatDistance/index": [
		38408,
		7,
		38408
	],
	"./zh-HK/_lib/formatDistance/index.js": [
		38408,
		7,
		38408
	],
	"./zh-HK/_lib/formatLong": [
		64131,
		7,
		64131
	],
	"./zh-HK/_lib/formatLong/": [
		64131,
		7,
		64131
	],
	"./zh-HK/_lib/formatLong/index": [
		64131,
		7,
		64131
	],
	"./zh-HK/_lib/formatLong/index.js": [
		64131,
		7,
		64131
	],
	"./zh-HK/_lib/formatRelative": [
		57346,
		7,
		57346
	],
	"./zh-HK/_lib/formatRelative/": [
		57346,
		7,
		57346
	],
	"./zh-HK/_lib/formatRelative/index": [
		57346,
		7,
		57346
	],
	"./zh-HK/_lib/formatRelative/index.js": [
		57346,
		7,
		57346
	],
	"./zh-HK/_lib/localize": [
		62651,
		7,
		62651
	],
	"./zh-HK/_lib/localize/": [
		62651,
		7,
		62651
	],
	"./zh-HK/_lib/localize/index": [
		62651,
		7,
		62651
	],
	"./zh-HK/_lib/localize/index.js": [
		62651,
		7,
		62651
	],
	"./zh-HK/_lib/match": [
		56470,
		7,
		56470
	],
	"./zh-HK/_lib/match/": [
		56470,
		7,
		56470
	],
	"./zh-HK/_lib/match/index": [
		56470,
		7,
		56470
	],
	"./zh-HK/_lib/match/index.js": [
		56470,
		7,
		56470
	],
	"./zh-HK/index": [
		26241,
		7,
		26241
	],
	"./zh-HK/index.d": [
		73651,
		9,
		73651
	],
	"./zh-HK/index.d.ts": [
		73651,
		9,
		73651
	],
	"./zh-HK/index.js": [
		26241,
		7,
		26241
	],
	"./zh-HK/index.js.flow": [
		82013,
		1,
		82013
	],
	"./zh-HK/package": [
		86682,
		3,
		86682
	],
	"./zh-HK/package.json": [
		86682,
		3,
		86682
	],
	"./zh-TW": [
		61956,
		9,
		61956
	],
	"./zh-TW/": [
		61956,
		9,
		61956
	],
	"./zh-TW/_lib/formatDistance": [
		42341,
		7,
		42341
	],
	"./zh-TW/_lib/formatDistance/": [
		42341,
		7,
		42341
	],
	"./zh-TW/_lib/formatDistance/index": [
		42341,
		7,
		42341
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		42341,
		7,
		42341
	],
	"./zh-TW/_lib/formatLong": [
		76463,
		7,
		76463
	],
	"./zh-TW/_lib/formatLong/": [
		76463,
		7,
		76463
	],
	"./zh-TW/_lib/formatLong/index": [
		76463,
		7,
		76463
	],
	"./zh-TW/_lib/formatLong/index.js": [
		76463,
		7,
		76463
	],
	"./zh-TW/_lib/formatRelative": [
		78396,
		7,
		78396
	],
	"./zh-TW/_lib/formatRelative/": [
		78396,
		7,
		78396
	],
	"./zh-TW/_lib/formatRelative/index": [
		78396,
		7,
		78396
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		78396,
		7,
		78396
	],
	"./zh-TW/_lib/localize": [
		58664,
		7,
		58664
	],
	"./zh-TW/_lib/localize/": [
		58664,
		7,
		58664
	],
	"./zh-TW/_lib/localize/index": [
		58664,
		7,
		58664
	],
	"./zh-TW/_lib/localize/index.js": [
		58664,
		7,
		58664
	],
	"./zh-TW/_lib/match": [
		8765,
		7,
		8765
	],
	"./zh-TW/_lib/match/": [
		8765,
		7,
		8765
	],
	"./zh-TW/_lib/match/index": [
		8765,
		7,
		8765
	],
	"./zh-TW/_lib/match/index.js": [
		8765,
		7,
		8765
	],
	"./zh-TW/index": [
		47370,
		7,
		47370
	],
	"./zh-TW/index.d": [
		75699,
		9,
		75699
	],
	"./zh-TW/index.d.ts": [
		75699,
		9,
		75699
	],
	"./zh-TW/index.js": [
		47370,
		7,
		47370
	],
	"./zh-TW/index.js.flow": [
		49014,
		1,
		49014
	],
	"./zh-TW/package": [
		25343,
		3,
		25343
	],
	"./zh-TW/package.json": [
		25343,
		3,
		25343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 38750;
module.exports = webpackAsyncContext;